export default {
	es: {
		guardar: "Guardar",
		volver: "< Volver",
		sin_definir: "Sin definir",
		guardar_datos: "Guardar datos",
		cancelar: "Cancelar",
		confirmar: "Confirmar",
		eliminar: "Eliminar",
		aceptar: "Aceptar",
		rechazar: "Rechazar",
		comenzar: "Comenzar",
		cerrar_sesion: "Cerrar sesión",
		manual_uso: "Manual de uso",
		ver_menos: "Ver menos",
		ver_mas: "Ver más",
		ver_todas: "Ver todas",
		inicio: "Inicio",
		ver_detalles: "Ver detalles",
		guardar: "Guardar",
		editar: "Editar",
		anadir: "Añadir",
		enviar: "Enviar",
		requerido: "Requerido",
		revisar: "Revisar",
		editar_oferta: "Editar oferta",
		duplicar_oferta: "Duplicar oferta",
		cerrar_oferta: "Cerrar oferta",
		eliminar_oferta: "Elimina oferta",
		ver_como_candidato: "Ver como candidato",
		practicas: "Prácticas",
		empleo: "Empleo",
		ver: "Ver",
		enlaces: {
			politica_privacidad: "/politica-de-privacidad",
			politica_cookies: "/politica-de-cookies",
			login: "/login",
			solicitar_cuenta: "/solicitar-cuenta",
			registroalumno: "/registro",
			encuestas: '/encuestas',
			encuesta: '/encuesta',
			eventos: '/eventos',
			eventospublico: '/evento-publico',
			documentacion: '/documentacion',
			guiaOrientacion: '/guias-orientacion',
			ofertas_practicas: '/ofertas-practicas',
			ofertas_empleo: '/ofertas-empleo',
			cv: '/cv',
			vercv: '/ver-cv',
			mis_candidaturas: '/mis-candidaturas',
			mis_practicas: '/mis-practicas',
			orientacion: '/orientacion-laboral',
			propuesta_practicas: '/propuesta-practicas',
			programapracticasactivos: '/programas-practicas-activos',
			solicitarcambiopracticas: '/solicitar-cambio-practicas',
			subirconvenio: '/subir-convenio-firmado',
			generarnuevoconvenio: '/nuevo-convenio-colaboracion',
			practicaseducacion: '/solicitudes-practicas-educacion',
			nueva_oferta: '/nueva-oferta',
			editar_oferta: '/editar-oferta',
			mi_empresa: '/mi-empresa',
			mi_perfil: '/mi-perfil',
			mis_ofertas: '/mis-ofertas',
			mi_oferta: '/oferta',
			programa_practicas: '/programa-practicas',
			visualizar_oferta: '/visor-oferta',
			restablecer_login: '/restablecer-login',
			restablecer_candidato: '/restablecer-candidato',
			setear_pass: '/establecer-login',
			proteccion_datos: '/proteccion-de-datos',
			acceso_saml: '/acceso',
			logout: '/logout',
			ayuda: '/ayuda',
			condicionespracticasuib: '/uib/condiciones-practicas',
			formulario_datos: '/formulario-datos',
			actualidad: '/actualidad',
			recursos: '/recursos'
		},
		encabezado: {
			home: 'Bienvenid@',
			cv: 'Mi currículum',
			cv_view: 'Currículum del candidato',
			eventos: 'Eventos',
			propuesta_practicas: "Propuesta de prácticas",
			politica_privacidad: "Política de privacidad",
			politica_cookies: "Política de cookies",
			login: "Inicio de sesión",
			solicitar_cuenta: "Nueva empresa",
			registro_alumno: "Registro",
			ofertas_practicas: 'Listado de ofertas de prácticas',
			ofertas_empleo: 'Listado de ofertas de empleo',
			ficha_oferta_alumno_empleo: 'Listado de ofertas de empleo',
			ficha_oferta_alumno_practicas: 'Listado de ofertas de prácticas',
			mis_candidaturas: 'Mis candidaturas',
			actualidad: 'Actualidad',
			recursos: 'Recursos',
			mis_practicas: 'Mis prácticas',
			encuestas: 'Encuestas',
			orientacion: 'Orientación laboral',
			nueva_oferta: 'Nueva oferta',
			editar_oferta: 'Editar oferta',
			mi_empresa: "Mi empresa",
			mi_perfil: "Mi perfil",
			documentacion: 'Documentación',
			guiasOrientacion: 'Guías Orientación',
			documentacion_empresa: 'Documentación',
			documentacion_alumno: 'Mi documentación',
			mis_ofertas: 'Mis ofertas',
			mi_oferta: 'Mi oferta',
			ficha_oferta_empresa: 'Mi oferta',
			restablecer_login: 'Restablecer Contraseña',
			restablecer_candidato: 'Restablecer Contraseña',
			programapracticasactivos: 'Programas de prácticas activos',
			setear_pass: 'Establecer Contraseña',
			proteccion_datos: 'Protección de datos',
			visor_oferta: "Ver como alumno",
			fichaProgramaActivo: "Programas activos",
			solicitudCambioPracticas: "Solicitud cambio de prácticas",
			solicitudesEducacion: "Solicitudes ofertas educación",
			subirConvenioFirmado: 'Subir convenio firmado',
			generarNuevoConvenio: 'Nuevo convenio de Colaboración',
			ayuda: 'Ayuda',
			condicionespracticasuib: "Condiciones prácticas",
			info_alumno: "Recuerda que si quieres realizar prácticas hasta el 31 de diciembre no solicites el título hasta pasada dicha fecha. En el caso de solicitar el título antes del 31 de diciembre perderás la condición de alumno y ya no podrás realizar prácticas.",
			formulario_datos: 'Formulario datos',
			formulario_incorporacion: 'Formulario de incorporación',
			falta_num_ss: 'Debido a la entrada en vigor del nuevo RD el real decreto-ley 2/2023, de 16 de marzo que entrará en vigor el 1 de enero 2024 es OBLIGATORIO nos facilites tu número de la Seguridad Social y adjuntes una copia del mismo. Accede a tu perfil para cumplimentar esta información:',
			noticias: 'Noticias',
			novedades: 'Novedades',
			no_actualidad: 'No hay actualidad para mostrar',
			ver_fichero: 'Ver fichero'
		},
		proteccion_datos: {
			titulo: "INFORMACIÓN ADICIONAL DE PROTECCIÓN DE DATOS:",
			estudiantes: {
				p1: "Le informamos de que el responsable del tratamiento de sus datos personales es la Universidad COLEGIO UNIVERSITARIO DE ESTUDIOS FINANCIEROS (en adelante, CUNEF), NIF: B-86969235, y domicilio a efectos de notificaciones en la calle C/ Leonardo Prieto Castro 2, 28040 – Madrid. CUNEF ha nombrado un Delegado de Protección de Datos, que tiene habilitado el siguiente canal de comunicación dpd@piconyasociados.es.",
				p2: "Los datos personales que facilite al cumplimentar los formularios serán tratados con la finalidad de crear y mantener su cuenta de acceso a la plataforma (incluyendo el posible envío de comunicados relativos a la plataforma, como información sobre las prácticas ofrecidas por las empresas, confirmación de inscripción a ofertas o cambios de estado en las candidaturas), así como para gestionar las prácticas y su inscripción en las ofertas de empleo publicadas. La base jurídica del tratamiento es el consentimiento, que podrá retirar en cualquier momento. La retirada de dicho consentimiento no afectará a la ejecución del contrato como alumno de CUNEF, y los tratamientos realizados con anterioridad mantendrán su licitud. Las categorías de datos tratadas con base en el consentimiento son: datos identificativos y de contacto, datos de características personales, datos académicos y profesionales y datos sobre aficiones o intereses, en su caso, así como cualquier otro dato que facilite a la plataforma. La autorización para tratar sus datos con este fin es voluntaria y, en caso de no otorgarla, no podrá inscribirse en las prácticas ni recibir información sobre ellas.",
				p3: "Le informamos de que los datos facilitados podrán ser comunicados a diferentes empresas ofertantes de prácticas y/o empleo, con las que CUNEF disponga de acuerdos de cooperación educativa, con la única finalidad de estudiar su solicitud y, en su caso, iniciar el proceso de selección.",
				p4: "Los datos serán conservados durante todo el tiempo que sea alumno de la Universidad o hasta que revoque su consentimiento, en su caso.",
				p5: "En cumplimiento de lo establecido en el Reglamento (UE) 2016/679, en la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y Garantía de los Derechos Digitales y demás normativa de desarrollo, le informamos que tiene derecho a acceder, rectificar y suprimir los datos, limitar su tratamiento, oponerse al tratamiento y ejercer su derecho a la portabilidad de los datos de carácter personal, todo ello de forma gratuita, mediante escrito remitido a la Universidad CUNEF – lopd@cunef.edu.",
				p6: "Frente a cualquier vulneración de sus derechos, especialmente cuando usted no haya obtenido satisfacción en su ejercicio, puede presentar una reclamación ante la Agencia Española de Protección de Datos (datos de contacto accesibles en www.agpd.es), bien a través de su sede electrónica o en su domicilio, en calle Jorge Juan, nº 6, C.P. 28001 de Madrid."
			},
			empresas: {
				p1: "Le informamos de que el responsable del tratamiento de sus datos personales es la Universidad COLEGIO UNIVERSITARIO DE ESTUDIOS FINANCIEROS (en adelante, CUNEF), NIF: B-86969235, y domicilio a efectos de notificaciones en la calle C/ Leonardo Prieto Castro 2, 28040 – Madrid. CUNEF ha nombrado un Delegado de Protección de Datos, que tiene habilitado el siguiente canal de comunicación dpd@piconyasociados.es.",
				p2: "Los datos personales que facilite serán tratados con la finalidad de crear una cuenta para acceder a la plataforma y gestionar su mantenimiento. La base jurídica es la ejecución de un contrato en el que el interesado es parte. La entrega de los datos es obligatoria; en caso contrario, no podría desarrollarse el objeto del contrato.",
				p3: "Los datos serán conservados durante el tiempo necesario para cumplir con la finalidad para la que se recabaron y, con posterioridad, por los plazos de prescripción de las posibles responsabilidades jurídicas de todo orden. Transcurridos dichos plazos se procederá al borrado de los datos.",
				p4: "Los datos no serán comunicados a terceros, salvo a las administraciones públicas en los casos previstos en la ley y a los alumnos cuando ello sea necesario para la gestión de las prácticas o de la formación ofrecida.",
				p5: "En cumplimiento de lo establecido en el Reglamento (UE) 2016/679, en la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y Garantía de los Derechos Digitales y demás normativa de desarrollo, le informamos que tiene derecho a acceder, rectificar y suprimir los datos, limitar su tratamiento, oponerse al tratamiento y ejercer su derecho a la portabilidad de los datos de carácter personal, todo ello de forma gratuita, mediante escrito remitido a la Universidad CUNEF – lopd@cunef.edu.",
				p6: "Frente a cualquier vulneración de sus derechos, especialmente cuando usted no haya obtenido satisfacción en su ejercicio, puede presentar una reclamación ante la Agencia Española de Protección de Datos (datos de contacto accesibles en www.agpd.es), bien a través de su sede electrónica o en su domicilio, en calle Jorge Juan, nº 6, C.P. 28001 de Madrid."
			}
		},
		ficha_oferta: {
			texto_programa_anadido: "Tienes este programa añadido a tu lista de programas informáticos"
		},
		formulario: {
			nombre: "Nombre",
			nombre_apellidos: "Nombre y apellidos",
			apellidos: "Apellidos",
			email: "Email",
			mensaje: "Mensaje",
			fecha_nacimiento: "Fecha de nacimiento",
			dia: "Día",
			mes: "Mes",
			anyo: "Año",
			area_interes: "Área de su interés",
			trabaja_actualmente: "¿Trabaja actualmente?",
			si: "Si",
			no: "No",
			carta_presentacion: "Carta de presentacion",
			meses: {
				Enero: "Enero",
				Febrero: "Febrero",
				Marzo: "Marzo",
				Abril: "Abril",
				Mayo: "Mayo",
				Junio: "Junio",
				Julio: "Julio",
				Agosto: "Agosto",
				Septiembre: "Septiembre",
				Octubre: "Octubre",
				Noviembre: "Noviembre",
				Diciembre: "Diciembre"
			},
			archivo_adjunto: "Adjuntar archivo",
			adjuntar_cv: "Adjuntar CV",
			introduce_mail: "Introduce tu email",
			pais: "País",
			telefono: "Teléfono",
			he_leido: "He leído y acepto la",
			y_acepto: "política de privacidad",
			enviar: "Enviar",
			enviado: "Enviado",
		},
		meses: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
		login: {
			iniciar_sesion: 'Iniciar sesión',
			acceder: 'Acceder',
			email: "Email",
			error_mail: "Por favor, indica tu email para logarte en el portal.",
			contrasena: "Contraseña",
			repetir_contrasena: "Repetir Contraseña",
			contrasena_olvidada: "He olvidado mi contraseña",
			introduce_email: 'Introduce tu email',
			email_mal: 'El email está mal formado',
			recuperar_pass: 'Recuperar mi contraseña',
			aun_no_registrado: "¿Aún no estas registrado/a?",
			acceder_SSO: "ACCEDER SSO UNIVERSIDAD",
			indica_mail: "Por favor, indica tu <strong>{{$t('oferta.email')}}</strong> para logarte en el portal.",
			selecciona_empresa: "Por favor, selecciona la empresa con la que quieres logarte.",
			titulacion: "Titulación",
			tipo_formacion: "Tipo de formación academica",
			selecciona_formacion: "Selecciona un tipo de formación",
			registrarme: "Registrarme",
			deseo_recibir: "Deseo recibir comunicaciones relacionadas con orientación y servicios relacionados con la formación superior y la UIB.",
			popup_rgpd: {
				titulo: 'Información adicional',
				detalle: 'Puede consultar la información adicional y detallada sobre Protección de Datos en este ',
				enlace: 'link.',
				boton: 'Consiento, acceder',
				acepto: 'He leído y acepto la información sobre protección de datos'
			},
			restablecer_pass: {
				titulo: 'Sigue los pasos para restablecer tu contraseña',
				intro: 'La contraseña debe contener al menos 8 caracteres y un número.',
				guardar: 'Guardar'
			},
			seteo_pass: {
				titulo: 'Sigue los pasos para establecer tu contraseña',
				intro: 'La contraseña debe contener al menos 8 caracteres y un número.',
				guardar: 'Guardar'
			},

		},
		registro: {
			encabezado: 'Cumplimenta el formulario a continuación para darte de alta en el sistema:',
			datos_usuario: "Datos del usuario de empresa",
			datos_personales: "Datos personales",
			nombre: "Nombre",
			apellidos: "Apellidos",
			DNI: "DNI/NIF/NIE",
			CIF: "CIF de la empresa",
			puesto: "Puesto / Cargo",
			departamento: "Departamento",
			telefono_1: "Teléfono",
			telefono_2: "Teléfono 2",
			email: "Email",
			sede: "Sede por defecto",
			cargo: "Cargo",
			idioma: "Idioma preferido de comunicación",
			tipo_contacto: "Tipo de Contacto",
			contrasena: "Contraseña",
			repetir_contrasena: "Repetir Contraseña",
			direccion: "Dirección",
			pais: "País",
			selecciona_pais: "-selecciona un país-",
			provincia: "Provincia",
			selecciona_provincia: "-Selecciona una provincia-",
			localidad: "Localidad",
			selecciona_localidad: "-Selecciona una localidad-",
			direccion: "Dirección",
			direccion_empresa: "Dirección Empresa",
			cp: "Código Postal",
			titulo_2: "A continuación introduce los datos de tu empresa para darte de alta en el sistema:",
			anadir_imagen: "Haz click para añadir la imagen",
			autorizar_logo: "Autorizar uso del logo",
			nombre_fiscal: "Nombre fiscal o Razón social",
			nombre_comercial: "Nombre comercial",
			tipo_sociedad: 'Tipo de Sociedad',
			selecciona_tipo_sociedad: "-Selecciona tipo de sociedad-",
			tipo_empresa: "Tipo de Empresa",
			privada: "Privada",
			publica: "Pública",
			startup: "Startup",
			eliminar: "Eliminar",
			descripcion: "Descripción",
			si: "Sí",
			no: "No",
			sector: "Sector",
			selecciona_sector: "-Selecciona un sector-",
			otro_sector: "Otro Sector",
			numero_empleados: "Número de empleados",
			selecciona_empleados: "-Selecciona un rango-",
			web: "Web",
			iban: "Número cuenta IBAN",
			descripcion_empresa: "Descripción de la empresa",
			'femenino': 'Femenino',
			'masculino': 'Masculino',
			telefono: "Teléfono",
			firmante: {
				titulo: "A continuación introduce los datos del representante legal de la empresa que firmará los convenios:",
				nombre: "Nombre del firmante",
				apellidos: "Apellidos del firmante",
				email: "Email del firmante",
				dni: "DNI del firmante",
				cargo: "Cargo del firmante",
				telefono: "Teléfono"
			},
			contacto: {
				nombre: "Nombre del contacto",
				apellidos: "Apellidos del contacto",
				email: "Email del contacto",
				telefono: "Teléfono"
			},
			delegado_proteccion_datos: {
				titulo: "Datos de contacto Delegado de protección de datos:",
				nombre: "Nombre",
				apellidos: "Apellidos",
				email: "Email",
				telefono: "Teléfono"
			},
			envio_facturas: {
				titulo: "Dirección envío de facturas",
				titulo_2: "Dirección de facturación"
			},
			anadir_direccion: "Añadir nueva dirección de facturación",
			perfil_sectorial: "Perfil sectorial",
			sector_actividad: "Sector de actividad",
			selecciona_sector_actividad: "-Selecciona un sector-",
			rango: "Rango de facturación",
			selecciona_rango: "-Selecciona un rango-",
			numero_empleados: "Número de empleados",
			selecciona_numero_empleados: "-Selecciona un rango-",
			anyo_fundacion: "Año de fundación",
			politica_1: "He leído y acepto la ",
			politica_2: "información sobre protección de datos​",
			popup_proteccion: {
				titulo: "INFORMACIÓN BÁSICA SOBRE PROTECCIÓN DE DATOS",
				intro: "Se recomienda que lea la siguiente información sobre privacidad antes de facilitar sus datos personales:",
				responsable_label: "Responsable:",
				responsable_text: "COLEGIO UNIVERSITARIO DE ESTUDIOS FINANCIEROS (CUNEF).",
				finalidad_label: "Finalidad:",
				finalidad_text: "Creación de una cuenta para acceder a la plataforma y su mantenimiento.",
				derechos_label: "Derechos:",
				derechos_text: "En las condiciones legales, tiene derecho a acceder, rectificar y suprimir los datos, a la limitación de su tratamiento, a oponerse al mismo y a su portabilidad.",
				informacion_adicional_label: "Información adicional:",
				informacion_adicional_text: "Puede consultar la información adicional y detallada sobre Protección de Datos en este",
				informacion_adicional_link: "enlace"
			},
			nuevo_contacto_titulo: "Datos del nuevo contacto de gestión",
			anadir_contacto: "Añadir contacto",
			nueva_cuenta_fiscal: "Datos de la cuenta nueva fiscal",
			domicilio_fiscal: "Domicilio Fiscal",
			poblacion: "Población",
			requiere_envio_postal: "Requiere envío postal facturas",
			domicilio_postal: "Domicilio para el envio postal de facturas",
			anadir_cuenta: "Añadir cuenta",
			datos_firmante: "Datos del firmante",
			area_conocimiento: "Área o rama de conocimiento",
			nombre_titulacion: "Nombre de la titulación",
			ano_inicio: "Año de inicio",
			ano_finalizacion: "Año de finalización",
			solicitar_cuenta: "Solicitar cuenta",
			seguir_empresa: "Seguir con los datos de la empresa",
			registrar_empresa: "Registrar Empresa",
			dni_pasaporte_nie: "DNI/NIF/NIE/Pasaporte",
			selecciona_nivel: "-Selecciona un nivel-",
			busca_area: 'Busca el área',
			busca_titulacion: 'Busca la titulación',
			firmaDigital: "Tipo de firma para convenio", 
			asume_coste_SS: "¿Su entidad acepta asumir el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social de los alumnos que realicen prácticas formativas o prácticas académicas externas en su institución tal y como recoge en el Real Decreto-ley 2/2023?",
			asume_coste_SS_Si: "Si, aceptamos asumir el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social del alumno, en el momento que sea de aplicación efectiva tal y como recoge el Real Decreto-ley 2/2023.",
			asume_coste_SS_No: "No Aceptamos. Solicitamos que sea CUNEF, la entidad que asuma el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social del alumno, en el momento que sea de aplicación efectiva tal y como recoge el Real Decreto-ley 2/2023."
		},
		home_empresa: {
			ofertas_practicas: "OFERTAS<strong>De prácticas</strong>",
			texto_ofertas_practicas: "Consulta y gestiona las ofertas de prácticas y las candidaturas recibidas.",
			nueva_practicas: "PUBLICAR<strong>Nueva oferta de prácticas",
			publicar_practicas: "Publica ofertas de prácticas, dirigidas a nuestros estudiantes.",
			nueva_propuesta: "SOLICITAR PRÁCTICA<strong>Propuesta de prácticas",
			publicar_propuesta: "Si no quieres dirigir una oferta a todos nuestros alumnos sino que ya conoces al estudiante que va a realizar la práctica. Haz tu propuesta de prácticas para el estudiante aquí.",
			ofertas_empleo: "OFERTAS<strong>De empleo</strong>",
			texto_ofertas_empleo: "Consulta y gestiona las ofertas de empleo y las candidaturas recibidas.",
			nueva_empleo: "PUBLICAR<strong>Nueva oferta de empleo",
			texto_nueva_empleo: "Publica ofertas de empleo para candidatos con hasta 3 años de experiencia."
		},
		mi_practica: {
			subir_documentacion: "Subir documentación",
			descargar_anexo: "Descargar Anexo Firmado",
			descargar_certificado: "Descargar certificado de realización de prácticas",
			descargar_poliza: "Descargar póliza del seguro",
			titulo_practicas: "Para poder incorporarte a la realización de estas prácticas es necesario:",
			pagar_creditos: "Pagar los créditos que se van a reconocer.",
			descarga: "Descarga",
			aqui: "aquí",
			documento_pago: "el documento de Carta de Pago con la información de cantidades debidas e instrucciones.",
			contratar_poliza: "Contratar una póliza de accidentes que te cubra estas prácticas",
			puedes_contratar: "Puedes contratar cualquier póliza de seguro, si lo deseas puedes contratar online",
			mensaje_documentos: "Una vez tengas <strong>listos</strong> los documentos, por favor <strong>digitalízalos y adjúntalos</strong> a continuación. Revisaremos que son válidos antes de firmar el contrato con la empresa.",
			digitaliza_documentos: "Una vez tengas <strong>listo</strong> el documento, por favor <strong>digitalízalo y adjúntalo</strong> a continuación. Revisaremos que es válido antes de firmar el contrato con la empresa.",
			adjuntar_pago: "Adjuntar resguardo de pago",
			adjuntar_seguro: "Adjuntar póliza de seguro",
			descarga_ficheros: "Descarga los siguientes ficheros, firmalos y adjuntalos de nuevo.",
			enviar: "Enviar",
			renuncia_practicas_SET: "Estas prácticas extracurriculares formarán parte de tu SET (Suplemento Europeo al Título) si cumples los requisitos exigidos legalmente, en caso de que no desees que se unan a SET, debes adjuntar documento de renuncia firmado. Puedes descargar la plantilla del documento",
			adjuntar_renuncia: "Adjuntar renuncia firmada",
			tutor_academico: "Tutor académico:",
			calificacion: "Calificación:",
			anexos_7: "Anexos 7",
			observaciones_tutor: "Observaciones del tutor:",
			documento_renuncia: "Documento de renuncia",
			nuevo_anexo_7: "Nuevo anexo 7",
			adjuntar: "Adjuntar"
		},
		mis_practicas: {
			titulo: "En esta sección encontrarás toda la documentación referente a tus prácticas.",
			zero_1: "No hay ninguna práctica o documentación de prácticas para mostrar.",
			gracias: "Muchas gracias.",
			emailJuridica: "practicas.derecho@comillas.edu",
			emailIngenieria: "practicas.ingenieria@comillas.edu",
			emailEconomica: "practicas.ade.ibs@comillas.edu",
			emailSanitaria: "practicas.soci.sani@comillas.edu",
			emailEducacion: "mvtorres@comillas.edu",
			emailRRII: "practicas.ri.com.ti@comillas.edu",
			emailInternacional: "jrmunoz@comillas.edu",
		},
		cambio_password: {
			titulo: "Cambiar contraseña",
			titulo_candidato: "¿Deseas cambiar tu contraseña?",
			contrasena_actual: "Contraseña actual",
			nueva_contrasena: "Nueva Contraseña",
			repetir_contrasena: "Repetir nueva Contraseña"
		},
		guia_orientacion: {
			titulo: "A continuación ponemos a tu disposición documentos en relación con tus prácticas o empleo, consejos y buenas prácticas que pueden ser de tu interés.",
			zero: "No hay guias de orientación"
		},
		mi_empresa: {
			intro: {
				cuerpo: 'Se muestran a continuación los datos principales de su empresa.',
				porfavor: 'Si tiene cualquier duda, por favor, ',
				contacte: 'contacte con nosotros.'
			},
			datos_empresa: "Datos de la empresa",
		},
		formulario_datos: {
			intro: {
				cuerpo: 'Se muestran a continuación los datos principales de su empresa. Actualice o rellene la siguiente información sobre su empresa.',
				porfavor: 'Por favor, ',
				contacte: 'contacte con nosotros.'
			},
			datos_empresa: "Datos de la empresa",
			datos_firmante: "Datos del firmante",
			datos_contacto: "Datos del contacto"
		},
	propuesta_practicas_form: {
		intro: {
			instructions: "Si has encontrado una empresa en la que realizar tus prácticas académicas curriculares o extracurriculares, puedes darla de alta aquí. La valoraremos y asignaremos si cumple con todos los requisitos exigidos.",
			pdf_description: "Documento resumen de toma de datos para hacer la propuesta de prácticas en este formulario.",
			unknown_data: "Si desconoces algún dato por favor indícanos \"desconocido\".",
			education_info: "Si eres estudiante de Máster en Profesorado de Educación Secundaria Obligatoria, Bachillerato, FP y Enseñanza de Idiomas puedes solicitar centro educativo para realizar tus prácticas, tanto si ya tienes plaza confirmada como si no."
		},
		actions: {
			download: "Descargar"
		},
		steps: {
			academics_title: "Datos académicos",
			company_title: "Datos de la empresa",
			contact_title: "Datos del contacto de la empresa",
			step_indicator: "Paso {current} de {total}"
		},
		labels: {
			select_degree: "Selecciona una titulación*",
			course: "Curso*",
			cif: "CIF (empresa) o NIF (autónomo)*",
			school_certificate: "Certificado de centro docente",
			employment_record: "Vida laboral",
			select_school_center: "Selecciona el centro educativo:",
			company_name: "Nombre de la empresa",
			company_cif: "CIF de la empresa",
			workplace_data: "Datos del centro de trabajo",
			locality: "Localidad*",
			postal_code_short: "CP*",
			trade_name: "Nombre comercial*",
			legal_name: "Nombre fiscal*",
			website: "Web",
			company_phone: "Teléfono de la empresa 1*",
			company_email: "Email de la empresa*",
			address: "Dirección*",
			postal_code: "Código postal*",
			signatory_name: "Nombre del firmante",
			signatory_surnames: "Apellidos del firmante",
			signatory_email: "Email del firmante",
			signatory_dni: "DNI del firmante",
			signatory_role: "Cargo del firmante",
			contact_name: "Nombre del contacto",
			contact_email: "Email del contacto",
			contact_role: "Puesto / Cargo*",
			contact_phone: "Teléfono 1"
		},
		placeholders: {
			select_degree: "Haz clic para seleccionar una titulación",
			school_center: "Centro educativo",
			select_sector: "-Selecciona un sector-",
			select_country: "-Selecciona un país-",
			select_province: "-Selecciona una provincia-",
			select_town: "-Selecciona una localidad-"
		},
		questions: {
			practice_type: "¿Qué tipo de práctica vas a solicitar/proponer?*",
			education_request: "¿Vas a realizar tu solicitud para las prácticas de una titulación de Educación y Profesorado?*",
			confirmed_place: "¿Tienes ya plaza confirmada en algún centro?"
		},
		options: {
			curricular: "Curricular",
			extracurricular: "Extracurricular",
			yes: "Sí",
			no: "No",
			confirmed_place_yes: "Sí, tengo una plaza confirmada en un centro educativo",
			confirmed_place_no: "No, deseo proponer un centro de mi interés para la realización de prácticas."
		},
		messages: {
			attention: "¡Atención!",
			no_confirmed_place_info: "Solamente en el caso de no tener confirmada tu plaza para la realización de prácticas en un centro educativo.",
			remaining_requests: "Cuentas con {count} solicitudes de centros restantes.",
			wait_for_confirmation: "¡Atención! Tienes que esperar la confirmación de la universidad para dar por validadas tus prácticas. Tu solicitud entrará a trámite y recibirás la resolución a través de la mensajería del campus.",
			enter_cif: "Introduce el CIF de la empresa donde vas a realizar las prácticas.",
			select_center: "Selecciona el centro de realización de las prácticas. Búscalo por provincia y nombre:",
			loading: "Cargando...",
			no_companies: "No hay empresas",
			review_company: "Comprueba que los datos de la empresa coinciden con los datos de la empresa donde vas a realizar las prácticas. En caso de tener dudas o detectar un error, escríbenos a",
			company_not_found: "El CIF proporcionado no existe en nuestra base de datos, por favor rellena los siguientes campos.",
			enter_contact_email: "Introduce el email de tu contacto en la empresa.",
			review_contact: "Comprueba que los datos de la empresa coinciden con los datos del contacto. En caso de tener dudas o detectar un error, escríbenos a",
			contact_not_found: "No tenemos datos en nuestra base de datos de tu contacto, por favor rellena los datos.",
			signatory_intro: "A continuación introduce los datos del representante legal de la empresa que firmará los convenios:",
			review_fields: "Por favor, revisa todos los campos para poder continuar"
		},
		buttons: {
			validate_company: "Validar empresa",
			validate_contact: "Validar contacto"
		},
		links: {
			company_not_found: "No encuentro la empresa"
		}
	},
	propuesta_practicas_empresa: {
		intro: "Si un alumno/a va a realizar prácticas en su empresa, puede dar de alta aquí todos los detalles. Valoraremos y formalizaremos su propuesta si, tanto las prácticas ofertadas como el candidato/a seleccionado/a, cumplen con los requisitos exigidos.",
		instructions_text: "Puede consultar las instrucciones de propuesta de prácticas ",
		instructions_link: "aquí",
		student_data_title: "Datos del alumno/a",
		select_program_option: "Selecciona un programa de prácticas",
		program_requirements: "No olvides revisar los requisitos de este programa para las ofertas de prácticas. Puedes consultar todos los detalles ",
		program_requirements_link: "aquí",
		enter_dni: "Introduce el DNI de candidato/a.",
		dni_label: "DNI/NIE/Pasaporte*",
		validate_candidate: "Validar candidato/a",
		verify_candidate_data: "Comprueba que los datos del candidato/a coinciden. Si tienes dudas, o hay algún error escríbenos a",
		candidate_name_label: "Nombre del candidato/a",
		candidate_degree_label: "Titulación del candidato/a*",
		candidate_degree_placeholder: "Introduce la titulación del alumno/a"
	},
		candidaturas_options: {
			aceptar: "Aceptar inscripción",
			rechazar: "Rechazar inscripción",
			motivos_rechazo: "Motivos del rechazo",
			selecciona_motivo: "- Selecciona un motivo de rechazo -",
			rechazar_preinscripcion: "Rechazar preinscripción",
		},
		oferta: {
			intro_editor: "Cumplimenta el formulario a continuación para crear una oferta nueva:",
			tipo_oferta: "Tipo de oferta",
			numero_plazas: "Número de plazas",
			experiencia: "Experiencia",
			experiencia_deseable: "Experiencia deseable",
			horario: "Horario",
			fecha_inicio: "Fecha de inicio",
			fecha_fin: "Fecha de finalización",
			tipo_contrato: "Tipo de contrato",
			salario: "Salario",
			creditos: "Créditos superados",
			otras_remuneraciones: "Otras remuneraciones",
			pais: "País",
			poblacion: "Población/Provincia",
			poblacion_only: "Población",
			provincia: "Provincia",
			sector: "Sector",
			area_funcional: "Área funcional",
			sede: "Sede/campus",
			beca: "Beca mensual",
			descripcion_puesto: "Descripción del puesto",
			tarea: "Tarea",
			tutores_disponibles: "Tutores disponibles",
			otras_tareas: "Otras tareas",
			programa_practicas: "Programa de prácticas",
			aviso_programa: "Importante consultar para comprobar requisitos obligatorios",
			enlace_inscripcion: "Enlace de inscripción",
			ir_enlace: 'Ir al enlace',
			idiomas: "Idiomas",
			anadir_idiomas: "Añadir Idiomas",
			empleo: "Empleo",
			practicas: "Prácticas",
			certificacion: "- Certificación mínima requerida:",
			requerido: "- Requerido",
			estudios_obligatorios: "Estudios obligatorios",
			estudios_deseables: "Estudios deseables",
			estudios_propuestos: "Estudios propuestos",
			requisitos_obligatorios: "Requisitos obligatorios",
			etiquetas: "Etiquetas",
			otros_obligatorios: "Otros obligatorios",
			edad_maxima: "Edad maxima",
			salario_maximo: "Salario Máximo",
			intereses_deseables: "Intereses deseables",
			intereses_obligatorios: "Intereses obligatorios",
			intereses_seleccionados: "Intereses seleccionados",
			competencias_obligatorias: "Competencias obligatorias",
			competencias_seleccionadas: "Competencias seleccionadas",
			paises_nacionalidad_obigatorios: "Paises de Nacionalidad obligatorios",
			paises_residencia_obligatorios: "Paises de Residencia obligatorios",
			provincia_residencia_obligatorios: "Provincia de Residencia obligatorios",
			paises_seleccionados: "Paises seleccionados",
			provincias_seleccionados: "Provincias seleccionadas",
			coche_propio: "Vehículo propio",
			obligatorio_quest: "¿Obligatorio?",
			carnet_conducir: "Carnet de conducir",
			disponible_extranjero: "Disponible para trabajar en el extranjero",
			disponible_residencia: "Disponible para cambio de residencia",
			trabajando_actualmente: "Trabajando actualmente",
			requisitos_deseables: "Requisitos deseables",
			otros_requisitos_deseables: "Otros Requisitos deseables",
			otros_requisitos_obligatorios: "Otros requisitos obligatorios",
			motivos_exclusion: "Motivos de exclusión",
			competencias_deseables: "Competencias deseables",
			paises_nacionalidad_deseables: "Paises de Nacionalidad deseables",
			paises_residencia_deseables: "Paises de Residencia deseables",
			provincia_residencia_deseables: "Provincia de Residencia deseables",
			programas_informaticos: "Programas informáticos",
			programas_informaticos_deseables: "Programas informáticos deseables",
			documentos_requeridos: "Documentos requeridos",
			documentos: "Documentos",
			marca_documentos: "Indique por favor qué documentos quiere que le remita el estudiante a parte del CV (ejemplo: Carta de presentación, Carta de recomendación, etc...). Consigne por favor cada documento de forma independiente.",
			categoria: "Categoría",
			marca_categoria: "Indique la categoría del recurso que desea filtrar.",
			anadir_otro_documento: "Solicitar candidato aporte documento",
			nombre_documento_candidato: "Nombre del documento a aportar por el candidato",
			inscribirme: "Inscribirme",
			desinscribirme: "Desinscribirme",
			ya_inscrito: "ya estas inscrito",
			cancelar_inscripcion: "Cancelar inscripción",
			buscar_mas_intereses: "Busca más intereses",
			atencion: "¡Atención!",
			tramitar_inscripcion: "Para tramitar tu inscripción en esta oferta debes presentar tu candidatura en la web de la empresa ofertante.",
			acceder: "Para acceder",
			pincha_aqui: "pincha aquí.",
			especialidad: "Especialidad",
			estado: "Estado",
			datos_practica: "Datos de la práctica",
			paso_4: "Paso 4 de 4",
			tareas_a_desarrollar: "Tareas a desarrollar",
			horario: "Horario",
			horario_practicas: "Horario de prácticas",
			idioma_realizacion_practica: "Idioma realización práctica",
			horario_trabajo: "Horario de trabajo",
			tengo_candidato: "Tengo candidato/a",
			horas_dia: "Horas al día",
			remuneracion: "Remuneración(€ brutos/mes)",
			otros_beneficios: "Otros beneficios",
			fechas_practica: "Fechas práctica",
			especificar_fechas: "Especificar fechas",
			no_definidas: "No definidas",
			oncorporacion_inmediata: "Incorporación inmediata",
			fecha_inicio: "Fecha de inicio",
			fecha_fin: "Fecha de fin",
			fecha_alta: "Fecha Alta",
			duracion_meses: "Duración (en meses)",
			dedicacion: "Dedicación (% jornada)",
			departamento: "Departamento",
			modalidad: "Modalidad",
			numero_dias_semana: "Numero de días por semana",
			dias_semana: "Días de la semana",
			vinculado_tfg: "Vinculado a TFG",
			nombre_tfg: "Nombre TFG",
			tutor_tfg: "Tutor/a TFG",
			solicitante: "Solicitante del servicio",
			centro_practicas: "Centro de prácticas",
			n_pedido: "Nº de pedido (si lo requiere)",
			observaciones: "Observaciones",
			info_adicional_facturacion: "Información adicional para facturación",
			datos_firmante: "Datos del firmante",
			nombre_firmante: "Nombre del firmante",
			apellidos_firmante: "Apellidos del firmante",
			email_firmante: "Email del firmante",
			telefono_firmante: "Teléfono del firmante",
			cargo_firmante: "Cargo del firmante",
			direccion: "Dirección",
			nombre_tutor_uni: "Nombre y apellidos del tutor de la Universidad",
			datos_tutor_empresa: "Datos del tutor en la empresa",
			nombre: "Nombre",
			apellidos: "Apellidos",
			email: "Email",
			telefono: "Teléfono",
			cargo: "Cargo",
			dni: "DNI",
			de_la_empresa: "de la empresa",
			CIF: "CIF",
			titulacion_especialidad: "Titulación o especialidad",
			titulacion: "Titulación/ Cargo",
			selecciona: "-Seleccionar-",
			selecciona_opcion: "-Selecciona una-",
			nombre_oferta: "Nombre de la oferta",
			numero_plazas: "Número de plazas",
			experiencia_requerida: "Experiencia requerida",
			experiencia_deseable: "Experiencia deseable",
			opciones_publicacion: "Opciones de publicación",
			url_inscripcion: "URL inscripción empresa",
			candidato_preferido: "Candidato/a preferido",
			datos_realizacion: "Datos de realización de la práctica",
			conocimientos_especificos: "Conocimientos especificos",
			formacion_adquirida: "Formación adquirida",
			seguimiento_previsto: "Seguimiento previsto",
			empresa_destino: "Empresa destino (solamente si es oferta de gestora/consultora ETT)",
			datos_tutor: "Datos del tutor/a de la empresa",
			para_estudiantes_ultimo_ano: "Para estudiantes de último año",
			curso_minimo_requerido : "Curso mínimo requerido",
			para_perfil_no_universitario: "Para perfil no universitario",
			activo_quest: "¿Activo?",
			ano_promo_maximo: "Año de promoción máximo",
			enviar_quest: "¿Enviar?",
			candidato_leer: "Candidato/a por leer",
			candidatos_leer: "Candidatos/as por leer",
			candidato_total: "Candidato/a en total",
			referencia: "Referència",
			candidatos_total: "Candidatos/as en total",
			ver_detalles: "Ver detalles",
			con_practicas: "- Con prácticas asignadas",
			fecha_caducidad: "Fecha de caducidad",
			buscar_mas_programa: "Busca más programas informáticos",
			programas_elegidos: "Programas informáticos elegidos",
			sin_programas: "Sin programas informáticos especificados",
			selecciona_idioma: "Selecciona un idioma",
			escribe_idioma: "Escribe aquí el idioma",
			indica_certificacion: "Indica aquí la certificación o nivel mínimo requerido",
			titulaciones: "Titulaciones",
			requeridas: "requeridas",
			deseables: "valorables",
			propuestas: "propuestas",
			a_las_que: "a las que se dirige la oferta",
			nivel: "Nivel",
			areas: "Áreas",
			cualquier_area: "Cualquier área",
			otros: "Otros",
			ninguna_titulacion: "Ninguna titulación concuerda con el filtro de nivel indicado.",
			eliminar_todas: "Eliminar todas",
			areas_dirige: "Áreas a las que se dirige la oferta",
			titulaciones_dirige: "Titulaciones a las que se dirige la oferta",
			selecciona_titulaciones: "Selecciona las titulaciones en el listado de la izquierda",
			cumplimentar: "Cumplimentar solo en el caso de que lo considere información relevante para los candidatos/as.",
			tipo_estudios: "Tipo de estudios",
			seleccione_izquierda: "Selecciona las áreas en el listado de la izquierda.",
			seleccione_algun_nivel: "Seleccione algún nivel para cargar las áreas asociadas",
			especialidad_titulacion: "Especialidad o titulación/es",
			puesto_trabajo: 'Puesto de trabajo',
			motivo_rechazo: "Motivo de rechazo",
			ayuda_estudio: "Ayuda al estudio",
			tutor_empresa: "Tutor de la empresa",
			nombre_tutor: "Nombre del tutor empresa",
			apellidos_tutor: "Apellidos del tutor empresa",
			email_tutor: "Email del tutor empresa",
			telefono_tutor: "Teléfono del tutor empresa",
			cargo_tutor: "Cargo del tutor empresa",
			titulacion_tutor: "Titulación del tutor empresa",
			departamento_tutor: "Departamento del tutor empresa",
			dni_tutor: "DNI del tutor empresa",
			no_definido: "No definido",
			candidatos: "Candidatos/as",
			exportar: "Exportar",
			no_hay_candidatos: "No hay candidatos/as en esta oferta",
			mas: "más",
			menos: "menos",
			empresa_destino_simple: "Empresa Destino",
			tipo_formacion: "Tipo de formación",
			niveles: "Niveles",
			areas: "Áreas",
			para_estudiantes_ultimo_curso: "Para estudiantes de último curso",
			duplicar_oferta_aviso: "Oferta duplicada correctamente ¿Quieres editarla ahora?",
			alumno_validado_uib: "Alumno validado por DOIP UIB",
			condicionespracticas: "He leído y estoy de acuerdo con las condiciones. <a target='_blank' href='/uib/condiciones-practicas'>Ver condiciones</a>",
			idioma: "Idioma",
			ofertacerrada: "Una oferta cerrada no estará visible ni recibirá nuevos candidatos. ¿Estás seguro de querer cerrar esta oferta?",
			eliminaroferta: "Se va a eliminar la oferta ¿Quieres continuar?",
			ofertaduplicada: "Oferta duplicada correctamente ¿Quieres editarla ahora?",
			controlCerraroferta: "¿Ha seleccionado a alguno de los candidatos propuestos por DOIP UIB?",
			cumplimentainformacion: "Por favor cumplimente la siguiente información:",
			nombrepersona: "Nombre y apellidos de la persona seleccionada",
			fechainiciocontrato: "Fecha de inicio del contrato",
			tipocontrato: "Tipo de contrato",
			nota_media: "Nota media",
			observaciones: "Observaciones",
			nombre_apellidos_dni: "Nombre, apellidos y DNI",
			ocultar_datos_empresa: 'Ocultar datos de la empresa',
			url_informacion_complementaria: 'URL para información complementaria',
			fichero_informacion_complementaria: 'Fichero información complementaria:',
			ver_fichero_adjunto: 'Ver fichero adjunto:',
			datos_firmante: "Datos del firmante",
			firmante: {
				nombre: "Nombre del firmante",
				apellidos: "Apellidos del firmante",
				email: "Email del firmante",
				dni: "DNI del firmante",
				cargo: "Cargo del firmante",
				telefono: "Teléfono"
			},
		},
		filtro_oferta: {
			buscar_nombre: "Busca por nombre del puesto",
			buscar_localizacion: "Buscar ubicación",
			buscar_titulacion: "Busca por titulación",
			buscar_puesto: "Busca por nombre del puesto",
			filtro_avanzado: "Filtro Avanzado",
			cerrar: "Cerrar",
			fecha_publicacion: "Fecha publicación",
			fecha_inicio_previsa: "Fecha de inicio de práctica prevista",
			fecha_inicio: "Fecha de inicio",
			filtrado_etiqueta: "Filtrado por etiquetas",
			omitir_inscritos: "Omitir ya inscritos",
			oferta_tfg: "Oferta TFG/TFM",
			ofertas_internacional: "Oferta internacional",
			ofertas_cv: "Ofertas que encajan con mi perfil/cv",
			busquedas_guardadas: "Búsquedas guardadas",
			guardar_busqueda: "Guardar búsqueda",
			borrar_filtros: "BORRAR FILTROS",
			ver: "Ver",
			fecha: "Fecha",
			ofertas_tfg: "Oferta TFG/TFM",
			se_han_encontrado: "Se han encontrado",
			oferta_singular: "oferta",
			oferta_plural: "ofertas",
			introduce_nombre_busqueda: "Introduce el nombre de la búsqueda",
			sobreescribe_existente: "ó sobreescribe una existente",
			selecciona_busqueda: "Selecciona una búsqueda",
			ver_historico: "Ver histórico de ofertas",
			ver_actuales: "Ver ofertas actuales",
			crear_oferta: "CREAR OFERTA",
			historico_ofertas: "Histórico de ofertas",
			no_hay_ofertas: "No hay ofertas coincidentes con tu búsqueda",
			solo_con_candidatos: "Sólo ofertas con candidatos/as sin leer",
			tienen_candidatos: "Tienen candidatos/as",
			caduca_pronto: "Caducan pronto",
			no_leidos: "Solo no leidos",
			modalidad: "Modalidad",
			puesto_Empresa: "Puesto/ Empresa",
			buscar_sector: "Buscar por sector"
		},
		popup_confirmacion: {
			recuerda: "¡Recuerda!",
			titulo: "Asegúrate de que los datos de tu perfil están actualizados antes de inscribirte a una oferta.",
			actualiza: "Actualízalo pinchando",
			aqui: "aquí.",
			confirma_titulo: "Por favor confirma que quieres ser candidato/a en esta oferta.",
			atencion: "¡Atención!",
			necesitamos_anadir: "Necesitamos que añadas los siguientes documentos para poder inscribirte a la oferta.",
			url_documento: "URL del documento",
			por_favor_adjunta: "Por favor, adjunta un archivo o url",
			alumnos_master: "Los alumnos de máster de 2 años de duración deben tener al menos el 50% de los créditos aprobados, a fecha de inicio de realización de las prácticas, para poder realizarlas. ¿Eres alumno de máster de duración inferior a 2 años, o has superado el 50% de los créditos?",
			inscripcion_externa: "La inscripción de esta oferta se realiza a través de la web de la empresa.",
			confirma_inscripcion_externa: "Por favor, confirma que quieres ser redirigido a la web de la empresa para inscribirte a la oferta.",
			inscrito: "Inscrito",
			abrir_inscripcion_externa: "Si no ha sido redirigido a la web de la empresa, puede acceder a través de este enlace:",
			copiar_enlace: "Copiar"
		},
		header: {
			hola: "Hola, ",
			oferta_practicas: "Buscar ofertas de prácticas",
			oferta_empleo: "Buscar ofertas de empleo",
			propuesta_practicas: "Propuesta de prácticas",
			candidaturas: "Mis candidaturas",
			practicas: "Mis prácticas",
			programas: "Programas",
			encuestas: "Encuestas",
			eventos: "Eventos",
			mi_cv: "Mi CV",
			guias_orientacion: "Guías Orientación",
			mis_ofertas: "Mis ofertas",
			nueva_oferta: "Nueva oferta",
			solicitar_cambio_practicas: "Solicitar cambio de prácticas",
			documentacion: "Documentación",
			solicitudes_practicas_educacion: "Solicitudes prácticas educación",
			encuestas: "Encuestas",
			mi_empresa: "Mi empresa",
			ayuda: "Ayuda",
			cerrar_sesion: "Cerrar sesión",
			manual_uso: "Manual de uso",
			solicitar_baja: "Solicitar baja",
			formulario_datos: 'Formulario datos',
			recursos: "Recursos",
			actualidad: "Actualidad"
		},
		image_uploader: {
			titulo: "Editar imagen de perfil"
		},
		notificaciones: {
			borrar_todo: "Borrar todo",
			importantes: "Importantes",
			otras_notificaciones: "Otras notificaciones",
			no_notificaciones: "No tienes notificaciones pendientes"
		},
		popup_borrar_cuenta: {
			titulo: "¿Desea solicitar la baja del servicio y la supresión de sus datos personales?",
			si: "Sí",
			no: "No"
		},
		popup_faltan_datos_empresa: {
			atencion: "¡Atención!",
			cuerpo_1: "Faltan datos obligatorios en tu perfil, por favor accede para completarlos.",
			cuerpo_2: "Faltan datos obligatorios en el perfil de tu empresa, por favor accede para completarlos.",
			ir_a_perfil: "Ir a mi Perfil",
			ir_a_empresa: "Ir a Mi empresa"
		},
		popup_datos_personales: {
			atencion: "¡Atención!",
			titulo: "Es necesario indiques tu número de teléfono actual. Podrás hacerlo desde la sección Mi perfil > Datos Generales.",
			ir_a_perfil: "Ir a mi Perfil"
		},
		solicitudes_educacion: {
			titulo: "En esta sección encontrarás la información de los estudiantes que han solicitado la realización de prácticas en su centro.",
			zero: "No hay documentación en estos momentos."
		},
		filtro_candidaturas: {
			buscar_nombre: "Busca por nombre del puesto",
			empleo: "Empleo",
			practicas: "Prácticas",
			filtro_avanzado: "Filtro Avanzado",
			cerrar: "Cerrar",
			estado: "Estado",
			ver: "Ver",
			borrar_filtros: "BORRAR FILTROS",
			estas_en: "Estas en",
			proceso_seleccion: "proceso de selección",
			procesos_seleccion: "procesos de selección",
			zero: "No hay procesos de selección coincidentes con tu búsqueda"
		},
		documentacion: {
			intro: "En esta sección encontrarás la documentación relacionada con las prácticas que se han realizado en tu empresa.",
			convenio_titulo: "Convenios de colaboración",
			caducado: "(Caducado) -",
			zero_convenio: "Aún no tienes ningún convenio",
			titulo_convenio: "Si lo deseas puedes solicitar y descargar el convenio de colaboración, o aportar el documento ya firmado por tu empresa:",
			nuevo_convenio: "Nuevo convenio",
			subir_convenio: "Subir convenio firmado",
			anexos_practicas: "Anexos de prácticas",
			zero_practicas: "Aún no tienes contenido",
			notas_formativas: "Notas formativas",
			en: "en",
			otros_documentos: "Otros documentos asociados a prácticas",
			zero_documentos: "Aún no tienes ningún documento de prácticas",
			otros_documentos_programas: "Otros documentos asociados a programas",
			zero_documentos_practicas: "Aún no tienes ningún documento asociado a programas",
			documentos_aportados_empresa: "Otros documentos aportados por la empresa",
			no_documentos_anadidos: "No hay documentos añadidos, pulsa en añadir documento para añadirlo",
			anadir_documentacion: "Añadir documentación",
			selecciona_documento: "Selecciona un documento",
			listado_documento: "Listado de documentos",
			otro_tipo_documento: "Otro tipo de documento",
			nombre_documento: "Nombre del documento",
			url_documento: "URL del documento",
		},
		encuestas: {
			titulo: "Encuestas",
			obligatorias: "Para continuar, responde todas las preguntas obligatorias",
			enviar: "Enviar",
			siguiente: "Siguiente",
			empezar_de_nuevo: 'Empezar de nuevo',
			pagina: "Página",
			datos_enviados: "Tus datos han sido enviados",
			muchas_gracias: "¡Muchas gracias!",
			iniciar_sesion: "Inicia sesión con tu usuario de perfil",
			empresa: "Empresa",
			candidato: "Candidato",
			usuario: "Usuario",
			contrasena: "Contraseña",
			acceder: "Acceder",
			o: 'ó',
			acceder_anonimamente: "Acceder anonimamente",
			contestar_pregunta: "Debes contestar a esta pregunta para continuar",
			zero: "No hay encuestas disponibles",
			titulo: "Encuestas Pendientes",
			cuerpo: "Por favor, antes de continuar, responda estas encuestas",
			no_puedes: "No puedes acceder al portal hasta que no hayas contestado las encuestas pendientes. Si no deseas responder en este momento, puedes cerrar tu sesión.",
		},
		eventos: {
			proximos: "Próximos eventos",
			pasados: "Eventos pasados",
			evento_destacado: "Evento destacado",
			desde: "Desde",
			hasta: "Hasta",
			organizado_por: "Organizado por",
			inscribirse: "Inscribirse",
			inscrito: "Inscrito",
			mas_informacion: "Más información",
			galeria: "Galería de imágenes",
			videos: "Vídeos",
			buscar_localizacion: "Buscar ubicación",
			buscar_categoria: "Buscar por categoría",
			buscar_nombre: "Buscar por nombre",
			eventos_pasados: "Eventos ya pasados",
			ver_mas: "Ver más"
		},
		comunicaciones: {
			titulo: "Comunicaciones"
		},
		guias: {
			titulo: "Últimas guías de orientación",
			zero: "No hay guias de orientación"
		},
		ofertas: {
			ultimas_practicas: "Últimas Ofertas de prácticas",
			practicas: "Prácticas",
			ultimas_empleo: "Últimas Ofertas de empleo",
			empleo: "Empleo",
			ofertas: "Ofertas",
			zero_ofertas: "No hay ofertas disponibles.",
			contrato: "Contrato",
			idContrato: "Contrato",
			salario: "Salario",
			areaFuncional: "Área Funcional",
			provincia: "Provincia",
			areasTitulaciones: "Áreas de titulaciones",
			nivelesTitulaciones: "Niveles de titulaciones",
			tiposFormacion: "Tipos de formación",
			tituloPrograma: "Programa",
			area: "Área",
			filtrar_titulacion: "Filtrar por titulación",
			tipoModalidadAsistencia: "Modalidad de asistencia"
		},
		cv: {
			nivel: "Nivel",
			programa_informatico: "Programa informático",
			certificado: "Certificado",
			sin_nivel: "Sin nivel definido",
			presentacion: "Presentación",
			anadir_presentacion: "Para añadir tu presenctación pulsa",
			aqui: "aquí",
			otros_intereses: "Otros intereses",
			tus_interes: "Tus intereses",
			sin_intereses: "Sin intereses especificados",
			escribe_interes: "Escribe algún interes, para comenzar a buscar",
			click_interes: "Haz click sobre el interes, para añadirlo",
			click_cambiar_imagen: "Haz click para cambiar la imagen",
			cambiar_contrasena: "Cambiar contraseña",
			idiomas: "Idiomas",
			idioma: "Idioma",
			sin_idiomas: "Sin idiomas añadidos, pulsa en añadir idioma para añadirlo",
			idioma_obligatorio: "El idioma y el nivel son campos obligatorios para añadir un idioma",
			nivel_no_definido: "Nivel no definido",
			nivel: "Nivel",
			nombre_certificado: "Nombre del certificado",
			estancia_extranjero: "Estancia en el extranjero",
			pais_estancia: "País de estancia",
			motivo_estancia: "Motivo de la estancia",
			duracion_meses: "Duración en meses",
			experiencia_profesional: "Experiencia profesional",
			anadir_nueva_experiencia: "Añadir nueva experiencia",
			sin_experiencia: "Sin experiencia",
			nivel_formativo: "Nivel formativo",
			actualidad: "Actualidad",
			puesto: 'Titulo del puesto',
			anadir_documento: "Añadir documento",
			sector_empresa: "Sector de la empresa",
			area_actividad_puesto: "Área de actividad del puesto",
			tipo_contrato: "Tipo de contrato",
			subtipo_contrato: "Subtipo de contrato",
			ver_adjunto: "Ver adjunto",
			ver_enlace: "Ver enlace",
			duracion: "Duración",
			fecha_inicio: "Fecha de inicio",
			fecha_fin: "Fecha de fin",
			provincia: "Provincia",
			empresa: "Empresa",
			enlace: "Enlace",
			descripcion_puesto: "Descripción del puesto",
			objetivo_profesional: "Objetivo profesional",
			escribe_descripcion: "Escribe una descripción de las tareas desempeñadas",
			anadir_fichero: "Añadir fichero adjunto",
			adjunto_correctamente: "Archivo adjunto correctamente",
			isla: "Isla",
			programas_informaticos: {
				titulo: "Programas informáticos",
				buscar: "Escribe para buscar",
				zero: "No hay programas informáticos añadidos",
				anadir: "Añadir Programa",
			},
			sectores_interes: {
				titulo: "Sectores de interés",
				buscar: "Escribe para buscar",
				zero: "No hay sectores de interés añadidos",
				anadir: "Añadir sector de interés",
			},
			documentacion_adjunta: "Documentación adjunta",
			documentacion_subida: "Documentación subida el",
			no_hay_documentos: "No hay documentos añadidos",
			pulsa_anadir_documentos: ", pulsa en añadir documento para añadirlo",
			anadir_documentacion: "Añadir documentación",
			selecciona_documento: "Selecciona un documento",
			listado_documento: "Listado de documentos",
			otro_tipo_documento: "Otro tipo de documento",
			nombre_documento: "Nombre del documento",
			url_documento: "URL del documento",
			documentacion_privada: "Documentación privada",
			no_documentos: "No hay documentos añadidos, pulsa en añadir documento para añadirlo",
			documentacion_ligada: "Documentación ligada a procesos",
			estancias: "Estancias",
			consentimientos_titulo: "Consentimientos",
			consentimientos_intro: "Marca los consentimientos que autorizas para tus estancias internacionales.",
			consentimiento_imagen: "Autorizo la publicación de mi imagen en los medios de CUNEF",
			consentimiento_contactos: "Autorizo la cesión de mis datos de contacto a futuros estudiantes de movilidad",
			consentimientos_guardados: "Consentimientos guardados",
			ver_documento: "Ver documento",
			firmar: "Firmar",
			firmado: "Firmado",
			listado_estancias: "Listado de estancias",
			no_estancias: "No tienes estancias.",
			datos_profesionales: "Datos profesionales",
			visitar: "Visitar",
			indica_link_perfil: "Indica link a tu perfil",
			trabajando_actualmente: "Trabajando actualmente",
			permiso_trabajo: "Permiso de trabajo en la UE",
			situacion_actual: "Situación actual",
			ocupado: "Ocupado",
			desempleado: "Desempleado",
			con: "Con",
			sin: "Sin",
			anos_experiencia: "Años de experiencia",
			sin_experiencia: "Sin experiencia",
			disfrutado_erasmus: "He estado de Erasmus o he disfrutado de otra beca de movilidad",
			minima_retribucion: "Mínima retribución",
			brutos_anuales: "/ brutos anuales",
			datos_personales: "Datos personales",
			dni: "DNI",
			fecha_nacimiento: "Fecha de nacimiento",
			genero: "Género",
			femenino: "Femenino",
			masculino: "Masculino",
			email_personal: "Email personal",
			email_estudiante: "Email de estudiante",
			avisos_en_email: "Avisos en el email personal",
			acepta_newsletter: "Acepta newsletter",
			idioma_comunicaciones: "Idioma preferido para las comunicaciones",
			movil: "Móvil",
			fijo: "Otro teléfono",
			telefono_contacto: "Teléfono de contacto",
			telefono_contacto_placeholder: "Ej.: 600123456 o +33 612345678",
			direccion_empadronamiento: "Dirección de empadronamiento",
			direccion_actual: "Dirección actual",
			direccion: "Dirección",
			iban: "Nº cuenta IBAN",
			seguridad_social: "Nº Seguridad social",
			pais_nacionalidad: "País de nacionalidad",
			pais_segunda_nacionalidad: "País de segunda nacionalidad",
			provincia_nacimiento: "Provincia de nacimiento",
			provincia: "Provincia",
			lugar_nacimiento: "Lugar de nacimiento",
			discapacidad: "Discapacidad superior al 33%",
			deseo_recibir_comunicaciones: "Deseo recibir comunicaciones relacionadas con orientación y servicios relacionados con la formación superior y la UIB:",
			nombre: "Nombre",
			primer_apellido: "Primer apellido",
			segundo_apellido: "Segundo apellido",
			tipo_identificacion: "Tipo de identificación",
			documento_identidad: "Documento de identidad",
			buscar: "Escribe para buscar",
			cp: "Código Postal",
			pais: "País",
			localidad: "Localidad",
			tipo_via: "Tipo de vía",
			numero: "Número",
			piso: "Piso",
			puerta: "Puerta",
			notas: "Notas",
			datos_academicos: "Datos académicos",
			formacion_complementaria: "Formación complementaria",
			anadir_titulacion: "Añadir nueva titulación",
			complementaria: "complementaria",
			centro: "Centro",
			nivel_academico: "Nivel académico",
			tipo: "Tipo",
			nota: "Nota",
			rama_ensenanza: "Rama de la enseñanza",
			duracion: "Duración",
			actual: "Actual",
			si: "Sí",
			no: "No",
			titulo: "Titulo",
			universidad: "Universidad/Lugar de estudios",
			calificacion: "Calificación",
			calificacion_media: "Calificación media del titulo",
			horas: "Horas",
			ambito: "Ambito de la enseñanza",
			selecciona_tipo: "- Selecciona un tipo -",
			certificacion: "Certificación",
			tienes_cerfificacion: "¿Tienes certificación?",
			competencias_profesionales: "Competencias profesionales",
			tus_competencias: "Tus competencias",
			sin_competencias: "Sin competencias profesionales especificadas",
			solicitar_sesion: "¿Necesitas ayuda para cumplimentar este apartado? Puedes solicitar una sesión gratuita de orientación con nosotros pinchando en este <a href='https://content.fueib.org/es/orientacion?hsCtaTracking=b23fd2f4-3b24-4c45-9d90-9fd88b353e09%7Cd6de5ac5-da0e-420e-a24c-dc6ecd1b9dba' target='_blank'>enlace</a> y te ayudaremos.",
			datos_interes: "Datos de interés",
			busqueda_activa_practicas: "Búsqueda activa de prácticas",
			busqueda_activa_empleo: "Búsqueda activa de empleo",
			disponible_extranjero: "Disponible para trabajar en el extranjero",
			permiso_conducir: "Permiso de conducir",
			disponible_cambio_residencia: "Disponible para cambio de residencia",
			coche_propio: "Vehículo propio",
			disponible_viajar: "Disponible para viajar",
			discapacidad_certificada: "Discapacidad certificada",
			carnet_moto: "Carnet de moto",
			moto_propia: "Moto propia",
			disponibilidad_jornadas: "Disponilidad de jornadas",
			periodo_preferencia_practicas: "Periodo preferencia de prácticas",
			selecciona: "Selecciona",
			anadir_idioma: "Añadir idioma",
			anadir_intereses: "Añadir intereses",
			nuevos_datos_academicos: "Nuevos datos académicos",
		},
		addtitulacion: {
			titulo: "Titulaciones a las que se dirige la oferta",
			seleccione_areas: "Seleccione área/s para filtrar titulaciones",
			borrar_areas: "Borrar todas las áreas",
			cualquier_area: "Cualquier área",
			escriba_aqui: "Escriba aquí para filtrar el listado de titulaciones a continuación",
			selecciona_titulacion: "Seleccione la titulación/es a la/s que se dirige la oferta haciendo clic sobre ella/s",
			ver_titulaciones: "Ver titulaciones de grado",
			listadas: "listadas",
			listados: "listados",
			cualquier_titulacion: "Cualquiera de estas titulaciones de grado",
			ver_titulaciones_postgrado: "Ver titulaciones de postgrado",
			cualquier_titulacion_postgrado: "Cualquiera de estas titulaciones de postgrado",
			ver_titulaciones_propio: "Ver titulaciones de Título propio",
			cualquier_titulacion_propio: "Cualquiera de estos títulos propios",
			lo_sentimos: "Lo sentimos no se han encontrado titulaciones que coincidan con la búsqueda",
			listado_titulaciones_seleccionadas: "Listado de titulaciones seleccionadas",
			eliminar_titulaciones: "Eliminar todas las titulaciones seleccionadas"
		},
		candidato: {
			nuevo: "Nuevo",
			cambiar_estado: "Cambiar estado",
			ver_cv: "Ver CV",
			detalles: "Detalles del candidato/a",
			selecciona_estado: "Selecciona un estado",
			seleccione_motivo: "Por favor seleccione el motivo de rechazo del candidato/a.",
			cambio_estado: "Cambio de estado",
			descargar_cv: "Descargar CV",
			cumplimentar_formulario_incorporacion: "Cumplimentar Formulario de Incorporación",
			pendiente_form_incorporacion: "Pendiente formulario de incorporación"

		},
		cambio_practicas: {
			identifica: "Identifica el alumno/a del que solicitan realizar prórroga o variación de sus condiciones de prácticas.",
			alumno: "Alumno",
			selecciona_oferta: "Selecciona la oferta",
			no_practicas: "Aún no tienes ninguna práctica sobre la que puedas solicitar un cambio.",
			alumno: "Alumno/a",
			selecciona_alumno: "Selecciona el alumno/a",
			detalles: "Detalles de la modificación",
			tipo_modificacion: "Tipo de modificación",
			selecciona_modificacion: "-Selecciona la modificación-",
			otros_detalles: "Otros detalles",
			adjunto: "Adjunto",
			solicitar_cambio: "Solicitar cambio"
		},
		popup_idioma: {
			titulo: "Vas a cambiar tu preferencia de idioma. ¿Quieres continuar?",
		},
		formulario_incorporacion: {
			formularioYaCumplimentado: "Este formulario de incorporación ya ha sido cumplimentado y el alumno ha sido seleccionado.",
			encabezado: "Revisa y completa el formulario de incorporación para corroborar la información de la práctica y poder proceder a seleccionar al alumno y formalizar la práctica.",

			persona_de_contacto: "Persona de contacto",
			contacto_nombre: "Nombre",
			contacto_apellidos: "Apellidos",
			contacto_cargo_departamento: "Cargo/Departamento",
			contacto_email: "E-mail",
			contacto_num_telefono: "Nº de Teléfono",

			persona_firmante_anexo_convenio: "Persona firmante del Anexo",
			persona_firmante_convenio_empresa: "Persona firmante del convenio empresa",
			firmante_nombre: "Nombre",
			firmante_apellidos: "Apellidos",
			firmante_cargo_departamento: "Cargo del firmante",
			firmante_email: "E-mail",
			firmante_telefono: "Teléfono",

			datos_alumno: "Datos del Alumno",
			alumno_dni: "DNI",
			alumno_nombre_apellidos: "Nombre y apellidos",
			alumno_titulacion: "Titulación",

			fecha_inicio: "Fecha de inicio",
			fecha_fin: "Fecha de fin",

			datos_periodo_practicas: "Datos sobre el Periodo de Prácticas",
			
			lugar_realizacion_practicas: "Lugar de realización de las prácticas",

			datos_tutor_empresa: "Datos del tutor en la empresa",
			tutor_nombre: "Nombre",
			tutor_apellidos: "Apellidos",
			tutor_cargo: "Cargo en Empresa",
			tutor_email: "E-mail",
			tutor_dni: "DNI",
			tutor_telefono: "Teléfono",

			horario: "Horario",
			num_horas_dia: "Número de horas al día",

			retribucion_euros_mes: "Retribución € brutos/mes",
			otras_remuneraciones: "Otras remuneraciones",
			descripcion_actividad: "Descripción detallada de la actividad a realizar por el alumno (imprescindible para valorar y aprobar su idoneidad)",
		},
		popup_aceptaSS: {
			info: "Información sobre la Seguridad Social",
			remunerada: "A partir del 1 de enero de 2024, tal y como establece el Real Decreto-Ley 2/2023 (artículo único ap.34). En el caso de <strong>las prácticas formativas remuneradas</strong>, el cumplimiento de las obligaciones de Seguridad Social corresponderá a la entidad u organismo que financie el programa de formación, que asumirá a estos efectos la condición de empresario.",
			no_remunerada: "A partir del 1 de enero de 2024, tal y como establece el Real Decreto-Ley 2/2023 (artículo único ap.34). En el caso de las prácticas formativas no remuneradas, el cumplimiento de las obligaciones de Seguridad Social corresponderá a la empresa, institución o entidad en la que se desarrollen aquellos, salvo que en el convenio o acuerdo de cooperación que, en su caso, se suscriba para su realización se disponga que tales obligaciones corresponderán al centro de formación responsable de la oferta formativa.<br><br> Si tenéis alguna duda o queréis hacernos algún comentario, por favor escribirnos un correo a la siguiente dirección: <a href='mailto:careers@cunef.edu'>careers@cunef.edu</a>.",
			entendido: "He leído y entiendo las obligaciones de Seguridad Social",
			aceptar: "Aceptar"
		},
		noticia: "Noticia",
		recurso: "Recurso",
		novedad: "Novedad"
	},
	ca: {
		guardar: "Desar",
		volver: "< Tornar",
		sin_definir: "Sense definir",
		guardar_datos: "Desar les dades",
		cancelar: "Cancel·lar",
		confirmar: "Confirmar",
		eliminar: "Eliminar",
		aceptar: "Acceptar",
		rechazar: "Rebutjar",
		comenzar: "Començar",
		cerrar_sesion: "Tancar sessió",
		manual_uso: "Manual de uso",
		ver_menos: "Veure menys",
		ver_mas: "Veure més",
		ver_todas: "Veure totes",
		inicio: "Inici",
		ver_detalles: "Veure detalls",
		guardar: "Desar",
		editar: "Editar",
		anadir: "Afegir",
		enviar: "Enviar",
		requerido: "Requerit",
		revisar: "Revisar",
		editar_oferta: "Editar oferta",
		duplicar_oferta: "Duplicar oferta",
		cerrar_oferta: "Tancar oferta",
		eliminar_oferta: "Elimina oferta",
		ver_como_candidato: "Veure com a candidat",
		practicas: "Pràctiques",
		empleo: "Ocupació",
		ver: "Veure",
		enlaces: {
			politica_privacidad: "/politica-de-privacidad",
			politica_cookies: "/politica-de-cookies",
			login: "/inici-de-sessio",
			solicitar_cuenta: "/solilicitar-compte",
			registroalumno: "/registre",
			encuestas: '/enquestes',
			encuesta: '/enquesta',
			eventos: '/esdeveniments',
			eventospublico: '/evento-publico',
			documentacion: '/documentacion',
			guiaOrientacion: '/guias-orientacion',
			ofertas_practicas: '/ofertes-practicas',
			ofertas_empleo: '/ofertes-feina',
			cv: '/cv',
			vercv: '/veure-cv',
			mis_candidaturas: '/les-meves-candidatures',
			mis_practicas: '/mis-practicas',
			orientacion: '/orientacion-laboral',
			propuesta_practicas: '/propuesta-practicas',
			programapracticasactivos: '/programas-practicas-activos',
			solicitarcambiopracticas: '/solicitar-cambio-practicas',
			subirconvenio: '/pujar-conveni-signat',
			generarnuevoconvenio: '/nuevo-convenio-colaboracion',
			practicaseducacion: '/solicitudes-practicas-educacion',
			nueva_oferta: '/nova-oferta',
			editar_oferta: '/editar-oferta',
			mi_empresa: '/la-meva-empresa',
			mi_perfil: '/el-meu-perfil',
			mis_ofertas: '/les-meves-ofertes',
			mi_oferta: '/oferta',
			programa_practicas: '/ca/programa-practicas',
			visualizar_oferta: '/visor-oferta',
			restablecer_login: '/restablir-iniciaur-sessio',
			restablecer_candidato: '/restablir-candidat',
			setear_pass: '/establir-inici-de-sessio',
			proteccion_datos: '/proteccion-de-datos',
			acceso_saml: '/acces',
			logout: '/final-de-sessio',
			ayuda: '/ajuda',
			condicionespracticasuib: "/uib/condicions",
			actualidad: '/actualidad',
			recursos: '/recursos'
		},
		encabezado: {
			home: 'Benvingut/da',
			cv: 'El meu currículum',
			cv_view: 'Currículum del candidato',
			eventos: 'Esdeveniments',
			propuesta_practicas: "Proposta de pràctiques",
			politica_privacidad: "Política de privadesa",
			politica_cookies: "Política de galetes",
			login: "Inici de la sessió",
			solicitar_cuenta: "Nova empresa",
			registro_alumno: "Registre",
			ofertas_practicas: "Llistat d'ofertes de pràctiques",
			ofertas_empleo: "Llistat d'ofertes de feina",
			ficha_oferta_alumno_empleo: "Llistat d'ofertes de feina",
			ficha_oferta_alumno_practicas: "Llistat d'ofertes de pràctiques",
			mis_candidaturas: 'Les meves candidatures',
			actualidad: 'Actualidad',
			recursos: 'Recursos',
			mis_practicas: 'Les meves pràctiques',
			encuestas: 'Enquestes',
			orientacion: 'Orientació laboral',
			nueva_oferta: 'Nova oferta',
			editar_oferta: 'Editar oferta',
			mi_empresa: "La meva empresa",
			mi_perfil: "El meu perfil",
			documentacion: 'Documentació',
			guiasOrientacion: "Guies d'orientació",
			documentacion_empresa: 'Documentació',
			documentacion_alumno: 'La meva documentació',
			mis_ofertas: 'Les meves ofertes',
			mi_oferta: 'La meva oferta',
			ficha_oferta_empresa: 'La meva oferta',
			restablecer_login: 'Restablir la contrasenya',
			restablecer_candidato: 'Restablir la contrasenya',
			programapracticasactivos: 'Programes de pràctiques actius',
			setear_pass: 'Establir contrasenya',
			proteccion_datos: 'Protecció de dades',
			visor_oferta: "Ver como alumno",
			fichaProgramaActivo: "Programes actius",
			solicitudCambioPracticas: "Sol·licitud canvi de pràctiques",
			solicitudesEducacion: "Sol·licituds ofertes educació",
			subirConvenioFirmado: 'Pujar conveni signat',
			generarNuevoConvenio: 'Nou conveni de col·laboració',
			ayuda: 'Ajuda',
			condicionespracticasuib: "Condicions practiques",
			formulario_incorporacion: 'Formulari d´incorporació',
			noticias: 'Notícies',
			novedades: 'Novetats',
			no_actualidad: 'No hi ha actualitat per mostrar',
			ver_fichero: 'Veure fitxer'
		},
		proteccion_datos: {
			titulo: "INFORMACIÓ ADDICIONAL DE PROTECCIÓ DE DADES:",
			estudiantes: {
				p1: "L'informem que el responsable del tractament de les seves dades personals és la Universitat COLEGIO UNIVERSITARIO DE ESTUDIOS FINANCIEROS (d'ara endavant, CUNEF), NIF: B-86969235, i domicili a efectes de notificacions al carrer C/ Leonardo Prieto Castro 2, 28040 – Madrid. CUNEF ha nomenat un Delegat de Protecció de Dades, amb el següent canal de comunicació habilitat dpd@piconyasociados.es.",
				p2: "Les dades personals que faciliti en emplenar els formularis es tractaran amb la finalitat de crear i mantenir el seu compte d'accés a la plataforma (incloent-hi l'enviament de comunicacions relacionades amb la plataforma, com informació sobre les pràctiques ofertes per les empreses, confirmació d'inscripció a ofertes o canvis d'estat en les candidatures), així com per gestionar les pràctiques i la seva inscripció a les ofertes d'ocupació publicades. La base jurídica del tractament és el consentiment, que podrà retirar en qualsevol moment. La retirada del consentiment no afectarà l'execució del contracte com a alumne de CUNEF, i els tractaments efectuats amb anterioritat mantindran la seva licitud. Les categories de dades tractades amb base en el consentiment són: dades identificatives i de contacte, dades de característiques personals, dades acadèmiques i professionals i dades sobre aficions o interessos, si escau, així com qualsevol altra dada que faciliti a la plataforma. L'autorització per tractar les seves dades amb aquesta finalitat és voluntària i, en cas de no atorgar-la, no es podrà inscriure a les pràctiques ni rebre informació sobre elles.",
				p3: "L'informem que les dades facilitades es podran comunicar a diferents empreses oferents de pràctiques i/o ocupació amb les quals CUNEF disposi d'acords de cooperació educativa, amb l'única finalitat d'estudiar la seva sol·licitud i, si escau, iniciar el procés de selecció.",
				p4: "Les dades es conservaran mentre sigui alumne de la Universitat o fins que retiri el seu consentiment, si escau.",
				p5: "En compliment del que estableix el Reglament (UE) 2016/679, la Llei orgànica 3/2018, de 5 de desembre, de Protecció de Dades Personals i garantia dels drets digitals, i la resta de normativa de desenvolupament, l'informem que té dret a accedir, rectificar i suprimir les dades, limitar-ne el tractament, oposar-se al tractament i exercir el dret a la portabilitat de les dades de caràcter personal, tot de manera gratuïta, mitjançant escrit adreçat a la Universitat CUNEF – lopd@cunef.edu.",
				p6: "Davant de qualsevol vulneració dels seus drets, especialment quan no hagi obtingut satisfacció en el seu exercici, pot presentar una reclamació davant l'Agència Espanyola de Protecció de Dades (dades de contacte disponibles a www.agpd.es), bé a través de la seva seu electrònica o presencialment al carrer Jorge Juan, nº 6, C.P. 28001 de Madrid."
			},
			empresas: {
				p1: "L'informem que el responsable del tractament de les seves dades personals és la Universitat COLEGIO UNIVERSITARIO DE ESTUDIOS FINANCIEROS (d'ara endavant, CUNEF), NIF: B-86969235, i domicili a efectes de notificacions al carrer C/ Leonardo Prieto Castro 2, 28040 – Madrid. CUNEF ha nomenat un Delegat de Protecció de Dades, amb el següent canal de comunicació habilitat dpd@piconyasociados.es.",
				p2: "Les dades personals que faciliti es tractaran amb la finalitat de crear un compte d'accés a la plataforma i gestionar-ne el manteniment. La base jurídica és l'execució d'un contracte en què l'interessat és part. L'aportació de les dades és obligatòria; en cas contrari, no es podria desenvolupar l'objecte del contracte.",
				p3: "Les dades es conservaran durant el temps necessari per complir la finalitat per a la qual es van recollir i, posteriorment, durant els terminis de prescripció de les possibles responsabilitats jurídiques de tota mena. Un cop transcorreguts aquests terminis, les dades seran eliminades.",
				p4: "Les dades no es comunicaran a cap tercer, excepte a les administracions públiques en els casos previstos a la llei i als alumnes quan sigui necessari per a la gestió de les pràctiques o de la formació oferta.",
				p5: "En compliment del que estableix el Reglament (UE) 2016/679, la Llei orgànica 3/2018, de 5 de desembre, de Protecció de Dades Personals i garantia dels drets digitals, i la resta de normativa de desenvolupament, l'informem que té dret a accedir, rectificar i suprimir les dades, limitar-ne el tractament, oposar-se al tractament i exercir el dret a la portabilitat de les dades de caràcter personal, tot de manera gratuïta, mitjançant escrit adreçat a la Universitat CUNEF – lopd@cunef.edu.",
				p6: "Davant de qualsevol vulneració dels seus drets, especialment quan no hagi obtingut satisfacció en el seu exercici, pot presentar una reclamació davant l'Agència Espanyola de Protecció de Dades (dades de contacte disponibles a www.agpd.es), bé a través de la seva seu electrònica o presencialment al carrer Jorge Juan, nº 6, C.P. 28001 de Madrid."
			}
		},
		ficha_oferta: {
			texto_programa_anadido: "Teniu aquest programa afegit a la vostra llista de programes informàtics"
		},
		formulario: {
			nombre: "Nom",
			nombre_apellidos: "Nom i cognoms",
			apellidos: "Cognoms",
			email: "Adreça electrònica",
			mensaje: "Missatge",
			fecha_nacimiento: "Data de naixement",
			dia: "Dia",
			mes: "Mes",
			anyo: "Any",
			area_interes: "Àrea del vostre interès",
			trabaja_actualmente: "¿Trabaja actualmente?",
			si: "Sí",
			no: "No",
			carta_presentacion: "Carta de presentació",
			meses: {
				Enero: "Gener",
				Febrer: "Febrer",
				Març: "Març",
				Abril: "Abril",
				Maig: "Maig",
				Juny: "Juny",
				Juliol: "Juliol",
				Agost: "Agost",
				Setembre: "Setembre",
				Octubre: "Octubre",
				Novembre: "Novembre",
				Desembre: "Desembre"
			},
			archivo_adjunto: "Adjuntar fitxer",
			adjuntar_cv: "Adjuntar CV",
			introduce_mail: "Introduïu la vostra adreça electrònica",
			pais: "País",
			telefono: "Telèfon",
			he_leido: "He llegit i accept la",
			y_acepto: "política de privacitat",
			enviar: "Enviar",
			enviado: "Enviat",
		},
		meses: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
		login: {
			iniciar_sesion: "Iniciau la sessió",
			acceder: "Accedir-hi",
			email: "Adreça electrònica",
			error_mail: "Per favor, indicau l'adreça electrònica per entrar",
			contrasena: "Contrasenya",
			repetir_contrasena: "Repetir la contrasenya",
			contrasena_olvidada: "He oblidat la contrasenya",
			introduce_email: "Introduïu la vostra adreça electrònica",
			email_mal: "L'adreça electrònica està mal formada",
			recuperar_pass: "Recuperar la contrasenya",
			aun_no_registrado: "Encara no estàs registrat?",
			acceder_SSO: "ACCEDIR SSO UNIVERSITAT",
			indica_mail: "Per favor, indicau el  <strong>{{$t('oferta.email')}}</strong> para logarte en el portal.",
			selecciona_empresa: "Per favor, Seleccionau l'empresa amb la qual voleu connectar",
			titulacion: "Titulació",
			tipo_formacion: "Tipus de formació acadèmica",
			selecciona_formacion: "Selecciona un tipus de formació",
			registrarme: "Registrar-me",
			deseo_recibir: "Desitjo rebre comunicacions relacionades amb orientació i serveis relacionats amb la formació superior i la UIB.",
			popup_rgpd: {
				titulo: "INFORMACIÓ AMPLIADA",
				detalle: "Si necessitau informació més detallada, podeu accedir a la Política de Protecció de Dades a",
				enlace: "aquest enllaç",
				boton: "Hi consent, accedir",
				acepto: 'He llegit i accepto la informació sobre protecció de dades'
			},
			restablecer_pass: {
				titulo: "Seguiu les passes per restablir la contrasenya",
				intro: "La contrasenya ha de contenir almenys 8 caràcters i un número",
				guardar: "Desar"
			},
			seteo_pass: {
				titulo: "Seguiu les passes per establir la contrasenya",
				intro: "La contrasenya ha de contenir almenys 8 caràcters i un número",
				guardar: "Desar"
			}
		},
		registro: {
			encabezado: "Emplenau el formulari a continuació per donar-vos d'alta en el sistema:",
			datos_usuario: "Dades de l'usuari d'empresa",
			datos_personales: "Dades personals",
			nombre: "Nom",
			apellidos: "Cognoms",
			DNI: "DNI/NIF/NIE",
			CIF: "CIF de l'empresa",
			puesto: "Posició / Càrrec",
			departamento: "Departament",
			telefono_1: "Telèfon 1",
			telefono: "Telèfon",
			telefono_2: "Telèfon 2",
			email: "Adreça electrònica",
			sede: "vostre per defecte",
			cargo: "Càrrec",
			idioma: "Idioma preferit de comunicació",
			tipo_contacto: "Tipus de contacte",
			contrasena: "Contrasenya",
			repetir_contrasena: "Repetir la contrasenya",
			direccion: "Adreça",
			pais: "País",
			seleccion_pais: "-Seleccionau un país-",
			provincia: "Província",
			seleccion_provincia: "-Seleccionau una província-",
			localidad: "Localitat",
			seleccion_localidad: "-Seleccionau una localitat-",
			direccion: "Adreça",
			direccion_empresa: "Adreça empresa",
			cp: "Codi postal",
			titulo_2: "A continuació, introduïu les dades de la vostra empresa per donar-vos d'alta al sistema:",
			anadir_imagen: "Clicau per afegir la imatge",
			autorizar_logo: "Autoritzar ús del logotip",
			nombre_fiscal: "Nom fiscal o raó social",
			nombre_comercial: "Nom comercial",
			tipo_sociedad: "Tipus de societat",
			seleccion_tipo_sociedad: "-Seleccionau tipus de societat-",
			tipo_empresa: "Tipus d'empresa",
			privada: "Privada",
			publica: "Pública",
			startup: "Empresa emergent",
			eliminar: "Eliminar",
			descripcion: "Descripció",
			si: "Sí",
			no: "No",
			sector: "Sector",
			seleccion_sector: "-Seleccionau un sector-",
			selecciona_pais: "-Seleccionau un país-",
			otro_sector: "Un altre sector",
			numero_empleados: "Nombre de treballadors",
			seleccion_empleados: "-Seleccionau un rang-",
			web: "Web",
			iban: "Número compte IBAN",
			descripcion_empresa: "Descripció de l'empresa",
			firmante: {
				titulo: "A continuació, introduïu les dades de la persona que signarà els convenis:",
				nombre: "Nom del signant",
				apellidos: "Cognoms del signant",
				email: "Email del firmante",
				dni: "DNI del firmante",
				cargo: "Càrrec del signant",
				telefono: "Telèfon"
			},
			envio_facturas: {
				titulo: "Adreça enviament de factures",
				titulo_2: "Adreça de facturació"
			},
			anadir_direccion: "Afegir nova adreça de facturació",
			perfil_sectorial: "Perfil sectorial",
			sector_actividad: "Sector d'activitat",
			selecciona_sector_actividad: "-Seleccionau un sector-",
			rango: "Rang de facturació",
			selecciona_rango: "-Seleccionau un rang-",
			numero_empleados: "Nombre de treballadors",
			selecciona_numero_empleados: "-Seleccionau un rang-",
			anyo_fundacion: "Any de fundació",
			politica_1: "He llegit i accept la",
			politica_2: "Política de privadesa",
			popup_proteccion: {
				titulo: "INFORMACIÓ BÀSICA SOBRE PROTECCIÓ DE DADES",
				intro: "Es recomana que llegiu la informació següent sobre privacitat abans de facilitar les vostres dades personals:",
				responsable_label: "Responsable:",
				responsable_text: "COLEGIO UNIVERSITARIO DE ESTUDIOS FINANCIEROS (CUNEF).",
				finalidad_label: "Finalitat:",
				finalidad_text: "Creació d'un compte per accedir a la plataforma i el seu manteniment.",
				derechos_label: "Drets:",
				derechos_text: "En les condicions legals, teniu dret a accedir, rectificar i suprimir les dades, a la limitació del seu tractament, a oposar-vos-hi i a la seva portabilitat.",
				informacion_adicional_label: "Informació addicional:",
				informacion_adicional_text: "Podeu consultar la informació addicional i detallada sobre Protecció de Dades en aquest",
				informacion_adicional_link: "enllaç"
			},
			nuevo_contacto_titulo: "Dades del nou contracte de gestió",
			anadir_contacto: "Afegir contacte",
			nueva_cuenta_fiscal: "Dades del compte nou fiscal",
			domicilio_fiscal: "Domicili fiscal",
			poblacion: "Població",
			requiere_envio_postal: "Requereix enviament postal de les factures",
			domicilio_postal: "Domicilio para el envio postal de facturas",
			anadir_cuenta: "Afegir compte",
			datos_firmante: "Datos del firmante",
			area_conocimiento: "Àrea o branca de coneixement",
			nombre_titulacion: "Nom de la titulació",
			ano_inicio: "Any d'inici",
			ano_finalizacion: "Any de finalització",
			solicitar_cuenta: "Sol·licitar compte",
			seguir_empresa: "Seguiu amb les dades de l'empresa",
			registrar_empresa: "Registrador Empresa",
			dni_pasaporte_nie: "DNI/NIF/NIE/Passaport",
			selecciona_nivel: "-Selecciona un nivell-",
			busca_area: "Cerca l'àrea",
			busca_titulacion: 'Cerca la titulació'

		},
		home_empresa: {
			ofertas_practicas: "OFERTES<strong>De pràctiques</strong>",
			texto_ofertas_practicas: "Consulta i gestiona les ofertes de pràctiques i les candidatures rebudes.",
			nueva_practicas: "PUBLICAR<strong>Nova oferta de pràctiques",
			publicar_practicas: "Publica ofertes de pràctiques, adreçades als nostres estudiants.",
			ofertas_empleo: "OFERTES<strong>De feina",
			texto_ofertas_empleo: "Consulta i gestiona les ofertes de feina i les candidatures rebudes.",
			nueva_empleo: "PUBLICAR<strong>Nova oferta de feina",
			texto_nueva_empleo: "Publica ofertes de feina."
		},
		mi_practica: {
			subir_documentacion: "Pujar documentació",
			descargar_anexo: "Descarregar annex signat",
			descargar_certificado: "Descarregar certificat de realització de pràctiques",
			descargar_poliza: "Descarregar pòlissa d'assegurança",
			titulo_practicas: "Per poder incorporar-vos a la realització d'aquestes pràctiques és necessari:",
			pagar_creditos: "Pagar els crèdits que es reconeixeran",
			descarga: "Descarregau",
			aqui: "aquí",
			documento_pago: "el document pagament amb la informació de quantitats degudes i instruccions",
			contratar_poliza: "Contractar una pòlissa d'accidents que us cobreixi aquestes pràctiques",
			puedes_contratar: "Podeu contractar qualsevol pòlissa d'assegurança Si ho voleu, podeu contractar-la en línia",
			mensaje_documentos: "Quan tingueu <strong>enllestits</strong> els documents, per favor <strong>digitalitzau-los i adjuntau-los</strong> a continuació Revisarem que són vàlids abans de signar el contracte amb l'empresa",
			digitaliza_documentos: "Quan tingueu  <strong>enllestit</strong> el document, per favor <strong>digitalitzau-lo i adjuntau-lo</strong> a continuació Revisarem que és vàlid abans de signar el contracte amb l'empresa",
			adjuntar_pago: "Adjuntar resguard de pagament",
			adjuntar_seguro: "Adjuntar pòlissa d'assegurança",
			descarga_ficheros: "Descarga los siguientes ficheros, firmalos y adjuntalos de nuevo.",
			enviar: "Enviar",
			tutor_academico: "Tutor acadèmic:",
			calificacion: "Qualificació:",
			anexos_7: "Annexos 7",
			observaciones_tutor: "Observacions del tutor:",
			documento_renuncia: "Document de renúncia",
			nuevo_anexo_7: "Nou annex 7",
			adjuntar: "Adjuntar"
		},
		mis_practicas: {
			titulo: "En aquesta secció trobareu tota la documentació sobre les vostres pràctiques",
			zero_1: "No hi ha cap pràctica o documentació de pràctiques per mostrar En cas de dubte, per favor ",
			zero_2: "contactau amb nosaltres"
		},
		cambio_password: {
			titulo: "Canviar contrasenya",
			titulo_candidato: "Voleu canviar la contrasenya?",
			contrasena_actual: "Contrasenya actual",
			nueva_contrasena: "Contrasenya nova",
			repetir_contrasena: "Repetir la nova contrasenya"
		},
		guia_orientacion: {
			titulo: "A continuació, posam a la vostra disposició documents en relació amb les vostres pràctiques o llocs de treball, consells i bones pràctiques que poden ser del vostre interès",
			zero: "No hi ha guies d'orientació"
		},
		mi_empresa: {
			intro: {
				cuerpo: "A continuació, apareixen les dades principals de la vostra empresa Si alguna no és correcta, o necessitau accedir, corregir o eliminar qualsevol detall de la informació",
				porfavor: "Per favor,",
				contacte: "contactau amb nosaltres"
			},
			datos_empresa: "Dades de l'empresa",
		},
		propuesta_practicas_form: {
			intro: {
				instructions: "Si has trobat una empresa on realitzar les teves pràctiques acadèmiques curriculars o extracurriculars, la pots donar d'alta aquí. La valorarem i l'assignarem si compleix tots els requisits exigits.",
				pdf_description: "Document resum de presa de dades per fer la proposta de pràctiques en aquest formulari.",
				unknown_data: "Si desconeixes alguna dada si us plau indica \"desconegut\".",
				education_info: "Si ets estudiant del Màster en Professorat d'Educació Secundària Obligatòria, Batxillerat, FP i Ensenyament d'Idiomes pots sol·licitar centre educatiu per realitzar les teves pràctiques, tant si ja tens plaça confirmada com si no."
			},
			actions: {
				download: "Descarregar"
			},
			steps: {
				academics_title: "Dades acadèmiques",
				company_title: "Dades de l'empresa",
				contact_title: "Dades del contacte de l'empresa",
				step_indicator: "Pas {current} de {total}"
			},
			labels: {
				select_degree: "Selecciona una titulació*",
				course: "Curs*",
				cif: "CIF (empresa) o NIF (autònom)*",
				school_certificate: "Certificat de centre docent",
				employment_record: "Vida laboral",
				select_school_center: "Selecciona el centre educatiu:",
				company_name: "Nom de l'empresa",
				company_cif: "CIF de l'empresa",
				workplace_data: "Dades del centre de treball",
				locality: "Localitat*",
				postal_code_short: "CP*",
				trade_name: "Nom comercial*",
				legal_name: "Nom fiscal*",
				website: "Web",
				company_phone: "Telèfon de l'empresa 1*",
				company_email: "Email de l'empresa*",
				address: "Adreça*",
				postal_code: "Codi postal*",
				signatory_name: "Nom del signant",
				signatory_surnames: "Cognoms del signant",
				signatory_email: "Email del signant",
				signatory_dni: "DNI del signant",
				signatory_role: "Càrrec del signant",
				contact_name: "Nom del contacte",
				contact_email: "Email del contacte",
				contact_role: "Lloc / Càrrec*",
				contact_phone: "Telèfon 1"
			},
			placeholders: {
				select_degree: "Fes clic per seleccionar una titulació",
				school_center: "Centre educatiu",
				select_sector: "-Selecciona un sector-",
				select_country: "-Selecciona un país-",
				select_province: "-Selecciona una província-",
				select_town: "-Selecciona una localitat-"
			},
			questions: {
				practice_type: "Quin tipus de pràctica vols sol·licitar/proposar?*",
				education_request: "Vols realitzar la sol·licitud per a les pràctiques d'una titulació d'Educació i Professorat?*",
				confirmed_place: "Ja tens plaça confirmada en algun centre?"
			},
			options: {
				curricular: "Curricular",
				extracurricular: "Extracurricular",
				yes: "Sí",
				no: "No",
				confirmed_place_yes: "Sí, tinc una plaça confirmada en un centre educatiu",
				confirmed_place_no: "No, vull proposar un centre del meu interès per a la realització de pràctiques."
			},
			messages: {
				attention: "Atenció!",
				no_confirmed_place_info: "Només en cas de no tenir confirmada la teva plaça per a la realització de pràctiques en un centre educatiu.",
				remaining_requests: "Disposes de {count} sol·licituds de centres restants.",
				wait_for_confirmation: "Atenció! Has d'esperar la confirmació de la universitat per donar per validades les teves pràctiques. La teva sol·licitud entrarà a tràmit i rebràs la resolució a través de la missatgeria del campus.",
				enter_cif: "Introdueix el CIF de l'empresa on realitzaràs les pràctiques.",
				select_center: "Selecciona el centre de realització de les pràctiques. Cerca'l per província i nom:",
				loading: "Carregant...",
				no_companies: "No hi ha empreses",
				review_company: "Comprova que les dades de l'empresa coincideixen amb les de l'empresa on realitzaràs les pràctiques. En cas de dubte o error, escriu-nos a",
				company_not_found: "El CIF proporcionat no existeix a la nostra base de dades, si us plau emplena els camps següents.",
				enter_contact_email: "Introdueix l'email del teu contacte a l'empresa.",
				review_contact: "Comprova que les dades de l'empresa coincideixen amb les dades del contacte. En cas de dubte o error, escriu-nos a",
				contact_not_found: "No tenim dades a la nostra base de dades del teu contacte, si us plau emplena les dades.",
				signatory_intro: "A continuació introdueix les dades del representant legal de l'empresa que signarà els convenis:",
				review_fields: "Si us plau, revisa tots els camps per poder continuar"
			},
			buttons: {
				validate_company: "Validar empresa",
				validate_contact: "Validar contacte"
			},
			links: {
				company_not_found: "No trob l'empresa"
			}
		},
		propuesta_practicas_empresa: {
			intro: "Si un alumne/a farà pràctiques a la seva empresa, pot donar d'alta aquí tots els detalls. Valorarem i formalitzarem la seva proposta si tant les pràctiques ofertades com el/la candidat/a seleccionat/da compleixen els requisits exigits.",
			instructions_text: "Podeu consultar les instruccions de proposta de pràctiques ",
			instructions_link: "aquí",
			student_data_title: "Dades de l'alumne/a",
			select_program_option: "Selecciona un programa de pràctiques",
			program_requirements: "No oblidis revisar els requisits d'aquest programa per a les ofertes de pràctiques. Pots consultar tots els detalls ",
			program_requirements_link: "aquí",
			enter_dni: "Introdueix el DNI del candidat/a.",
			dni_label: "DNI/NIE/Passaport*",
			validate_candidate: "Validar candidat/a",
			verify_candidate_data: "Comprova que les dades del candidat/a coincideixen. Si tens dubtes o hi ha algun error, escriu-nos a",
			candidate_name_label: "Nom del candidat/a",
			candidate_degree_label: "Titulació del candidat/a*",
			candidate_degree_placeholder: "Introdueix la titulació de l'alumne/a"
		},
		candidaturas_options: {
			aceptar: "Acceptar inscripció",
			rechazar: "Rebutjar la inscripció",
			motivos_rechazo: "Motius del rebuig",
			selecciona_motivo: "- Seleccionau un motiu de rebuig -",
			rechazar_preinscripcion: "Rebutjar la preinscripció",
		},
		oferta: {
			intro_editor: "Emplenau el formulari a continuació per crear una oferta nova:",
			tipo_oferta: "Tipus d'oferta",
			numero_plazas: "Nombre de places",
			experiencia: "Experiència",
			experiencia_deseable: "Experiència desitjable",
			horario: "Horari",
			fechas_practica: "Dates práctica",
			especificar_fechas: "Especificar dates",
			no_definidas: "No definides",
			oncorporacion_inmediata: "Incorporació inmediata",
			fecha_inicio: "Data de començament",
			fecha_fin: "Data de finalització",
			tipo_contrato: "Tipus de contracte",
			salario: "Salari",
			otras_remuneraciones: "Altres remuneracions",
			pais: "País",
			poblacion: "Població/Província",
			poblacion_only: "Població",
			provincia: "Província",
			sector: "Sector",
			area_funcional: "Àrea funcional",
			sede: "vostre/campus",
			beca: "Beca mensual",
			descripcion_puesto: "Descripció del lloc",
			tarea: "Tasca",
			otras_tareas: "Altres tasques",
			tutores_disponibles: "Tutors disponibles",
			programa_practicas: "Programa de pràctiques",
			aviso_programa: "Important consultar-ho per comprovar els requisits obligatoris",
			enlace_inscripcion: "Enllaç d'inscripció",
			ir_enlace: "Anar a l'enllaç",
			idiomas: "Idiomes",
			anadir_idiomas: "Afegir Idiomes",
			empleo: "Treball",
			practicas: "Pràctiques",
			certificacion: "- Certificació mínima requerida:",
			requerido: "- Requerit",
			estudios_obligatorios: "Estudis obligatoris",
			estudios_deseables: "Estudis desitjables",
			requisitos_obligatorios: "Requisits obligatoris",
			etiquetas: "Etiquetes",
			otros_obligatorios: "Altres obligatoris",
			edad_maxima: "Edad maxima",
			salario_maximo: "Salari màxim",
			intereses_deseables: "Interessos desitjables",
			intereses_obligatorios: "Interessos obligatoris",
			intereses_Seleccionaudos: "Interessos Seleccionauts",
			competencias_obligatorias: "Competències obligatòries",
			competencias_selecionadas: "Competències Seleccionaudes",
			paises_nacionalidad_obigatorios: "Paises de Nacionalidad obligatorios",
			paises_residencia_obligatorios: "Paises de Residencia obligatorios",
			provincia_residencia_obligatorios: "Província de residència obligatòria",
			paises_Seleccionaudos: "Paises Seleccionaudos",
			provincias_Seleccionaudos: "Províncies Seleccionaudes",
			coche_propio: "Cotxe propi",
			obligatorio_quest: "Obligatori?",
			carnet_conducir: "Carnet de conduir",
			disponible_extranjero: "Disponibilitat per treballar a l'estranger",
			disponible_residencia: "Disponibilitat per canviar de residència",
			trabajando_actualmente: "Treballant actualment",
			requisitos_deseables: "Requisits desitjables",
			otros_requisitos_deseables: "Altres requisits desitjables",
			otros_requisitos_obligatorios: "Altres requisits obligatoris",
			motivos_exclusion: "Motiu d'exclusió",
			deseables: "desitjables",
			requeridas: "requerides",
			creditos: "Crèdits superats",
			competencias_deseables: "Competències desitjables",
			paises_nacionalidad_deseables: "Paises de Nacionalidad deseables",
			paises_residencia_deseables: "Paises de Residencia deseables",
			provincia_residencia_deseables: "Província de residència desitjable",
			programas_informaticos: "Programes informàtics",
			programas_informaticos_deseables: "Programes informàtics desitjables",
			documentos_requeridos: "Documents requerits",
			documentos: "Documents",
			marca_documentos: "Indiqueu quins documents voleu que us remeti l'estudiant (exemple: Carta de presentació, Carta de recomanació, etc...). Consigneu si us plau cada document de forma independent.",
			categoria: "Categoría",
			marca_categoria: "Indiqui la categoria del recurs que vulgui filtrar.",
			anadir_otro_documento: "Sol·licitar quin candidat aporti document",
			nombre_documento_candidato: "Nom del document que ha d'aportar el candidat",
			inscribirme: "Inscriure'm",
			desinscribirme: "Desinscriure'm",
			ya_inscrito: "ya estas inscrito",
			cancelar_inscripcion: "Cancel·lar inscripció",
			atencion: "Atenció!",
			tramitar_inscripcion: "Per tramitar la vostra inscripció en aquesta oferta heu de presentar la candidatura a la web de l'empresa oferent",
			acceder: "Per accedir",
			pincha_aqui: "clicau aquí",
			especialidad: "Especialitat",
			estado: "Estat",
			datos_practica: "Dades de la pràctica",
			paso_4: "Passa 4 de 4",
			tareas_a_desarrollar: "Tasques a desenvolupar",
			horario: "Horari",
			horas_dia: "Hores al dia",
			remuneracion: "Remuneració",
			otros_beneficios: "Altres beneficis",
			fecha_inicio: "Data de començament",
			fecha_fin: "Data de finalització",
			fecha_alta: "Data d'alta",
			duracion_meses: "Durada (en mesos)",
			dedicacion: "Dedicació (% jornada)",
			departamento: "Departament",
			modalidad: "Modalitat",
			numero_dias_semana: "Nombre de dies per setmana",
			dias_semana: "Dies de la setmana",
			vinculado_tfg: "Vinculado a TGF",
			nombre_tfg: "Títol del TFG",
			tutor_tfg: "Tutor del TFG",
			solicitante: "Sol·licitant del servei",
			centro_practicas: "Centre de pràctiques",
			nota_media: "Nota mitjana",
			n_pedido: "Núm de comanda (si ho requereix)",
			observaciones: "Observacions",
			info_adicional_facturacion: "Informació addicional per a la facturació",
			datos_firmante: "Dades del signant",
			nombre_firmante: "Nom del signant",
			apellidos_firmante: "Cognoms del signant",
			email_firmante: "Adreça electrònica del signant",
			telefono_firmante: "Telèfon del signant",
			cargo_firmante: "Càrrec del signant",
			direccion: "Adreça",
			nombre_tutor_uni: "Nom i cognoms del tutor de la Universitat",
			datos_tutor_empresa: "Datos del tutor en la empresa",
			nombre: "Nom",
			apellidos: "Cognoms",
			email: "Adreça electrònica",
			telefono: "Telèfon",
			cargo: "Càrrec",
			dni: "DNI",
			de_la_empresa: "de l'empresa",
			CIF: "CIF",
			titulacion_especialidad: "Titulació o especialitat",
			titulacion: "Titulació",
			selecciona: "Seleccionau",
			selecciona_opcion: "-Seleccionau una-",
			nombre_oferta: "Nom de l'oferta",
			numero_plazas: "Nombre de places",
			experiencia_requerida: "Experiència requerida",
			experiencia_deseable: "Experiència desitjable",
			opciones_publicacion: "Opcions de publicació",
			url_inscripcion: "URL inscripció empresa",
			candidato_preferido: "Candidat preferit",
			datos_realizacion: "Dades de realització de la pràctica",
			conocimientos_especificos: "Coneixements específics",
			formacion_adquirida: "Formació adquirida",
			seguimiento_previsto: "Seguiment previst",
			empresa_destino: "Empresa destí (només si és oferta de gestoria, consultora o ETT)",
			datos_tutor: "Dades del tutor/a de l'empresa",
			para_estudiantes_ultimo_ano: "Per a estudiants del darrer any",
			para_perfil_no_universitario: "Per a un perfil no universitari",
			activo_quest: "Actiu?",
			ano_promo_maximo: "Any de promoció màxim",
			enviar_quest: "Enviar?",
			candidato_leer: "Candidat per llegir",
			candidatos_leer: "Candidats per llegir",
			candidato_total: "Candidat  en total",
			candidatos_total: "Candidats en total",
			referencia: "Referència",
			ver_detalles: "Veure detalls",
			con_practicas: "- Amb pràctiques assignades",
			fecha_caducidad: "Data de caducitat",
			buscar_mas_programa: "Cerca més programes informàtics",
			programas_elegidos: "Programes informàtics triats",
			sin_programas: "Sense programes informàtics especificats",
			selecciona_idioma: "Seleccionau un idioma",
			escribe_idioma: "Escriviu aquí l'idioma",
			indica_certificacion: "Indicau aquí la certificació o nivell mínim requerit",
			titulaciones: "Titulacions",
			requerides: "requerides",
			desitjables: "desitjables",
			a_las_que: "a les quals s'adreça l'oferta",
			nivel: "Nivell",
			areas: "Àrees",
			cualquier_area: "Qualsevol àrea",
			otros: "Altres",
			ninguna_titulacion: "Cap titulació no concorda amb el filtre de nivell indicat",
			eliminar_todas: "Eliminar-les totes",
			areas_dirige: "Àrees a les quals s'adreça l'oferta",
			titulaciones_dirige: "Titulacions a les quals s'adreça l'oferta",
			selecciona_titulaciones: "Seleccionau les titulacions del llistat de l'esquerra",
			cumplimentar: "Cumplimentar solo en el caso de que lo considere información relevante para los candidatos/as.",
			tipo_estudios: "Tipus d'estudis",
			seleccione_izquierda: "Seleccionau les àrees del llistat de l'esquerra",
			seleccione_algun_nivel: "Seleccionau algun nivell per carregar les àrees associades",
			especialidad_titulacion: "Especialitat o titulació/ons",
			puesto_trabajo: "Lloc de treball",
			motivo_rechazo: "Motiu de rebuig",
			ayuda_estudio: "Ajuda a l'estudi",
			tutor_empresa: "Tutor de la empresa",
			nombre_tutor: "Nom del tutor d'empresa",
			apellidos_tutor: "Cognoms del tutor empresa",
			email_tutor: "Email del tutor empresa",
			telefono_tutor: "Teléfono del tutor empresa",
			cargo_tutor: "Càrrec del tutor empresa",
			titulacion_tutor: "Titulación del tutor empresa",
			departamento_tutor: "Departamento del tutor empresa",
			dni_tutor: "DNI del tutor empresa",
			no_definido: "No definit",
			candidatos: "Candidats",
			exportar: "Exportar",
			no_hay_candidatos: "No hi ha candidats en aquesta oferta",
			mas: "més",
			menys: "menys",
			empresa_destino_simple: "Empresa destí",
			tipo_formacion: "Tipus de formació",
			niveles: "Nivells",
			areas: "Àrees",
			para_estudiantes_ultimo_curso: "Per a estudiants del darrer curs",
			duplicar_oferta_aviso: "Oferta duplicada correctament La vols editar ara?",
			alumno_validado_uib: "Alumne validat per DOIP UIB",
			condicionespracticas: "He llegit i estic d'acord amb les condicions.<a target='_blank' href='/uib/condicions'>Veure les condicions</a>",
			idioma: 'Idioma',
			ofertacerrada: "Una oferta tancada no serà visible ni rebrà noves candidatures. Estau segurs/es de voler tancar aquesta oferta?",
			eliminaroferta: "Esborrarà l'oferta Vols continuar?",
			ofertaduplicada: "Oferta duplicada correctament La vols editar ara?",
			controlCerraroferta: "Heu seleccionat algun dels candidats/es proposats/des pel DOIP?",
			cumplimentainformacion: "Si us plau empleni la següent informació:",
			nombrepersona: "Nom i llinatges de la persona seleccionada",
			fechainiciocontrato: "Data d'inici del contracte",
			tipocontrato: "Tipus de contracte",
			horario_practicas: "Horari de pràctiques",
			idioma_realizacion_practica: "Idioma realització pràctica",
			horario_trabajo: "Horari de feina",
			tengo_candidato: "Tinc candidat/a",
			observaciones: "Observacions",
			nombre_apellidos_dni: "Nom, llinatges i DNI",
			ocultar_datos_empresa: 'Ocultar dades de l’empresa'
			
		},
		filtro_oferta: {
			buscar_nombre: "Cerca per nom del lloc",
			buscar_localizacion: "Cerca per localització",
			buscar_titulacion: "Cerca per titulació",
			buscar_puesto: "Cerca per nom del lloc",
			filtro_avanzado: "Filtre avançat",
			cerrar: "Tancar",
			fecha_publicacion: "Data de publicació",
			fecha_inicio_previsa: "Data de començament de la pràctica prevista",
			fecha_inicio: "Data de començament",
			filtrado_etiqueta: "Filtrat per etiquetes",
			omitir_inscritos: "Ometre els inscrits",
			oferta_tfg: "Oferta TFG/TFM",
			ofertas_internacional: "Oferta internacional",
			ofertas_cv: "Ofertes que encaixen amb el meu perfil/cv",
			busquedas_guardadas: "Cerques guardades",
			guardar_busqueda: "Desar la cerca",
			borrar_filtros: "ESBORRAR FILTRES",
			ver: "Veure",
			fecha: "Data",
			se_han_encontrado: "S'han trobat",
			oferta_singular: "oferta",
			oferta_plural: "ofertes",
			introduce_nombre_busqueda: "Introduïu el nom de la cerca",
			sobreescribe_existente: "ó sobreescribe una existente",
			selecciona_busqueda: "Seleccionau una cerca",
			ver_historico: "Veure històric d'ofertes",
			ver_actuales: "Veure ofertes actuals",
			crear_oferta: "CREAR OFERTA",
			historico_ofertas: "Històric d'ofertes",
			no_hay_ofertas: "No hi ha ofertes coincidents amb la vostra cerca",
			solo_con_candidatos: "Només ofertes amb candidats sense llegir",
			tienen_candidatos: "Tenen candidats ",
			caduca_pronto: "Caduquen aviat",
			no_leidos: "Solo no leidos",
			modalidad: "Modalitat"
		},
		popup_confirmacion: {
			recuerda: "Recorda!",
			titulo: "Assegurau-vos que les dades del vostre perfil estan actualitzades abans d'inscriure-us a una oferta",
			actualiza: "Actualitza'l clicant",
			aqui: "aquí",
			confirma_titulo: "Per favor, confirmau que voleu ser candidat en aquesta oferta",
			atencion: "Atenció!",
			necesitamos_anadir: "Cal que afegiu els documents següents per poder-vos inscriure a l'oferta",
			url_documento: "URL del document",
			por_favor_adjunta: "Per favor, adjuntau un arxiu o una URL",
			alumnos_master: "Els alumnes d'un màster de 2 anys de durada han de tenir almenys el 50% dels crèdits aprovats en haver de començar les pràctiques per poder fer-les Sou un alumne de màster de durada inferior a 2 anys o heu superat el 50% dels crèdits?",
			inscrito: "Inscrito",
			abrir_inscripcion_externa: "Si no ha sido redirigido a la web de la empresa, puede acceder a través de este enlace:",
			copiar_enlace: "Copiar"
		},
		encuestas: {
			titulo: "Enquestes pendents",
			cuerpo: "Per favor, abans de continuar, responeu aquestes enquestes",
			no_puedes: "No podreu accedir al portal fins que no hàgiu contestat les enquestes pendents Si no voleu respondre en aquest moment, podeu tancar la sessió",
			
		},
		header: {
			hola: "Hola, ",
			oferta_practicas: "Cercar ofertes de pràctiques",
			oferta_empleo: "Cercar ofertes de feina",
			propuesta_practicas: "Proposta de pràctiques",
			candidaturas: "Les meves candidatures",
			practicas: "Les meves pràctiques",
			programas: "Programes",
			encuestas: "Enquestes",
			eventos: "Esdeveniments",
			mi_cv: "El meu CV",
			guias_orientacion: "Guies d'orientació",
			mis_ofertas: "Les meves ofertes",
			nueva_oferta: "Nova oferta",
			solicitar_cambio_practicas: "Sol·licitar canvi de pràctiques",
			documentacion: "Documentació",
			solicitudes_practicas_educacion: "Sol·licituds pràctiques educació",
			encuestas: "Enquestes",
			mi_empresa: "La meva empresa",
			ayuda: "Ajuda",
			cerrar_sesion: "Tancar sessió",
			manual_uso: "Manual de uso",
			solicitar_baja: "Sol·licitar baixa"
		},
		image_uploader: {
			titulo: "Editar imatge de perfil"
		},
		notificaciones: {
			borrar_todo: "Esborrar-ho tot",
			importantes: "Importants",
			otras_notificaciones: "Altres notificacions",
			no_notificaciones: "No teniu notificacions pendents"
		},
		popup_borrar_cuenta: {
			titulo: "Voleu sol·licitar la baixa del servei i la supressió de les vostres dades personals?",
			si: "Sí",
			no: "No"
		},
		popup_faltan_datos_empresa: {
			atencion: "Atenció!",
			cuerpo_1: "Falten dades obligatòries en el vostre perfil Per favor, entrau-hi per completar-les",
			cuerpo_2: "Falten dades obligatòries en el perfil de la vostra empresa Per favor, entrau-hi per completar-les",
			ir_a_perfil: "Anar al meu perfil",
			ir_a_empresa: "Anar a la meva empresa"
		},
		popup_datos_personales: {
			atencion: "Atenció!",
			titulo: "Cal que indiquis el teu número de telèfon actual. Podràs fer-ho des de la secció El meu perfil > Dades Generals.",
			ir_a_perfil: "Anar al meu perfil"
		},
		solicitudes_educacion: {
			titulo: "En aquesta secció trobareu la informació dels estudiants que han sol·licitat fer les pràctiques en el vostre centre",
			zero: "No hi ha documentació en aquests moments"
		},
		filtro_candidaturas: {
			buscar_nombre: "Cerca per nom del lloc",
			empleo: "Treball",
			practicas: "Pràctiques",
			filtro_avanzado: "Filtre avançat",
			cerrar: "Tancar",
			estado: "Estat",
			ver: "Veure",
			borrar_filtros: "ESBORRAR FILTRES",
			estas_en: "Estas en",
			proceso_seleccion: "procés de selecció",
			procesos_seleccion: "processos de selecció",
			zero: "No hi ha processos de selecció coincidents amb la vostra cerca"
		},
		documentacion: {
			intro: "En aquesta secció trobareu la documentació relacionada amb les pràctiques que s'han fet a la vostra empresa",
			convenio_titulo: "Convenis de col·laboració",
			caducado: "(Caducat) -",
			zero_convenio: "Encara no teniu cap conveni",
			titulo_convenio: "Si ho desitjau, podeu sol·licitar i descarregar el conveni de col·laboració, o aportar el document ja signat per la vostra empresa:",
			nuevo_convenio: "Nou conveni",
			subir_convenio: "Pujar conveni signat",
			anexos_practicas: "Annexos de pràctiques",
			zero_practicas: "Encara no teniu contingut",
			notas_formativas: "Notes formatives",
			en: "en",
			otros_documentos: "Altres documents associats a pràctiques",
			zero_documentos: "Encara no teniu cap document de pràctiques",
			otros_documentos_programas: "Altres documents associats a programes",
			zero_documentos_practicas: "Encara no teniu cap document associat a programes",
			documentos_aportados_empresa: "Altres documents aportats per l'empresa",
			no_documentos_anadidos: "No hi ha documents afegits Pitjau a «Afegir document» per afegir-los",
			anadir_documentacion: "Afegir documentació",
			Seleccionau_documento: "Seleccionau un document",
			listado_documento: "Llistat de documents",
			otro_tipo_documento: "Un altre tipus de document",
			nombre_documento: "Nom del document",
			url_documento: "URL del document",
		},
		encuestas: {
			titulo: "Enquestes",
			obligatorias: "Per continuar, responeu totes les preguntes obligatòries",
			enviar: "Enviar",
			pagina: "Pàgina",
			datos_enviados: "Les vostres dades han estat enviades",
			muchas_gracias: "Moltes gràcies!",
			Iniciaur_sesion: "Iniciau la sessió amb el vostre perfil d'usuari",
			empresa: "Empresa",
			candidato: "Candidato",
			usuario: "Usuario",
			contrasena: "Contrasenya",
			acceder: "Accedir-hi",
			o: "ó",
			acceder_anonimamente: "Acceder anonimamente",
			contestar_pregunta: "Heu de contestar aquesta pregunta per poder continuar",
			zero: "No hi ha enquestes disponibles",
			siguiente: "Següent",
			empezar_de_nuevo: 'Començar de nou',
		},
		eventos: {
			proximos: "Pròxims esdeveniments",
			pasados: "Esdeveniments passats",
			evento_destacado: "Esdeveniment destacat",
			desde: "Des de",
			hasta: "Fins",
			organizado_por: "Organitzat per",
			inscribirse: "Inscriure's",
			inscrito: "Inscrit",
			mas_informacion: "Més informació",
			galeria: "Galeria d'imatges",
			videos: "Vídeos",
			buscar_localizacion: "Cercar per localització",
			buscar_categoria: "Cercar per categoria",
			buscar_nombre: "Cercar per nom",
			eventos_pasados: "Esdeveniments passats",
			ver_mas: "Veure més"
		},
		comunicaciones: {
			titulo: "Comunicacions"
		},
		guias: {
			titulo: "Darreres guies d'orientació",
			zero: "No hi ha guies d'orientació"
		},
		ofertas: {
			ultimas_practicas: "Darreres ofertes de pràctiques",
			practicas: "Pràctiques",
			ultimas_empleo: "Darreres ofertes d'ocupació",
			empleo: "Treball",
			ofertas: "Ofertes",
			zero_ofertas: "No hi ha ofertes disponibles",
			contrato: "Contracte",
			salario: "Salari",
			areaFuncional: "Àrea funcional",
			provincia: "Província",
			areasTitulaciones: "Àrees de titulacions",
			nivelesTitulaciones: "Nivells de titulacions",
			tiposFormacion: "Tipus de formació",
			tituloPrograma: "Programes",
			idContrato: "Contracte",
			area: "Àrea",
			filtrar_titulacion: "Filtrar per titulació",
			tipoModalidadAsistencia: "Modalitat dassistència"
		},
		cv: {
			nivel: "Nivell",
			programa_informatico: "Programa informàtic",
			certificado: "Certificat",
			sin_nivel: "Sense nivell definit",
			presentacion: "Presentació",
			anadir_presentacion: "Per afegir la vostra presentació pitjau",
			aqui: "aquí",
			otros_intereses: "Altres interessos",
			tus_interes: "Els vostres interessos",
			sin_intereses: "Sense interessos especificats",
			escribe_interes: "Escribe algún interes, para comenzar a buscar",
			click_interes: "Haz click sobre el interes, para añadirlo",
			click_cambiar_imagen: "Clicau per canviar la imatge",
			cambiar_contrasena: "Canviar contrasenya",
			idiomas: "Idiomes",
			idioma: "Idioma",
			sin_idiomas: "Sense idiomes afegits Premeu a «Afegir idioma» per afegir-lo",
			idioma_obligatorio: "L'idioma i el nivell són camps obligatoris per afegir un idioma",
			nivel_no_definido: "Nivell no definit",
			nivel: "Nivell",
			nombre_certificado: "Nom del certificat",
			estancia_extranjero: "Estada a l'estranger",
			pais_estancia: "País d'estada",
			motivo_estancia: "Motiu de l'estància",
			duracion_meses: "Durada en mesos",
			experiencia_profesional: "Experiència professional",
			anadir_nueva_experiencia: "Afegir nova experiència",
			buscar_mas_intereses: "Cerca més interessos",
			sin_experiencia: "Sense experiència",
			actualidad: "Actualitat",
			puesto: "Títol del lloc de feina",
			sector_empresa: "Sector de l'empresa",
			area_actividad_puesto: "Àrea d'activitat del lloc",
			tipo_contrato: "Tipus de contracte",
			subtipo_contrato: "Subtipus de contracte",
			ver_adjunto: "Veure l'adjunt",
			ver_enlace: "Veure enllaç",
			duracion: "Durada",
			fecha_inicio: "Data de començament",
			fecha_fin: "Data de finalització",
			provincia: "Província",
			empresa: "Empresa",
			enlace: "Enllaç",
			nivel_formativo: "Nivell formatiu",
			descripcion_puesto: "Descripció del lloc",
			objetivo_profesional: "Objectiu professional",
			escribe_descripcion: "Escriviu una descripció de les tasques exercides",
			anadir_fichero: "Afegir fitxer adjunt",
			adjunto_correctamente: "Arxiu adjuntat correctament",
			selecciona_documento: "Selecciona un document",
			'femenino': 'Femení',
			'masculino': 'Masculí',
			programas_informaticos: {
				titulo: "Programes informàtics",
				buscar: "Escriviu per cercar",
				zero: "No hi ha programes informàtics afegits Pitjau a «Afegir» per a afegir-los",
				anadir: "Añadir Programa",
			},
			documentacion_adjunta: "Documentació adjunta",
			documentacion_subida: "Documentació pujada el",
			no_hay_documentos: "No hi ha documents afegits",
			pulsa_anadir_documentos: ", Clicau a afegir document per afegir-lo",
			anadir_documentacion: "Afegir documentació",
			Seleccionau_documento: "Seleccionau un document",
			listado_documento: "Llistat de documents",
			otro_tipo_documento: "Un altre tipus de document",
			nombre_documento: "Nom del document",
			url_documento: "URL del document",
			documentacion_privada: "Documentació privada",
			no_documentos: "No hi ha documents afegits Pitjau a «Afegir document» per afegir-los",
			documentacion_ligada: "Documentació lligada a processos",
			estancias: "Estades",
			consentimientos_titulo: "Consentiments",
			consentimientos_intro: "Marca els consentiments que autoritzes per a les teves estades internacionals.",
			consentimiento_imagen: "Autoritzo la publicació de la meva imatge als mitjans de CUNEF",
			consentimiento_contactos: "Autoritzo la cessió de les meves dades de contacte a futurs estudiants de mobilitat",
			consentimientos_guardados: "Consentiments desats",
			ver_documento: "Veure document",
			firmar: "Signar",
			firmado: "Signat",
			listado_estancias: "Llistat d'estades",
			no_estancias: "No tens estades.",
			datos_profesionales: "Dades professionals",
			visitar: "Visitar",
			isla: "Illa",
			indica_link_perfil: "Indicau l'enllaç al vostre perfil",
			trabajando_actualmente: "Treballant actualment",
			permiso_trabajo: "Permís de treball a la UE",
			situacion_actual: "Situación actual",
			ocupado: "Ocupado",
			desempleado: "Desempleado",
			con: "Con",
			sin: "Sin",
			anos_experiencia: "Anys d'experiència",
			sin_experiencia: "Sense experiència",
			disfrutado_erasmus: "He estat d'Erasmus o he gaudit d'una altra beca de mobilitat",
			minima_retribucion: "Mínima retribució",
			brutos_anuales: "/ bruts anuals",
			datos_personales: "Dades personals",
			dni: "DNI",
			fecha_nacimiento: "Data de naixement",
			genero: "Gènere",
			femenino: "Femení",
			masculino: "Masculí",
			email_personal: "Adreça electrònica personal",
			email_estudiante: "Adreça electrònica de l'estudiant",
			avisos_en_email: "Avisos a l'adreça electrònica personal",
			acepta_newsletter: "Accepta el butlletí",
			idioma_comunicaciones: "Idioma preferit per a les comunicacions",
			movil: "Mòbil",
			fijo: "Telèfon fix",
			telefono_contacto: "Teléfono de contacto",
			telefono_contacto_placeholder: "Ex.: 600123456 o +33 612345678",
			direccion_empadronamiento: "Adreça d'empadronament",
			direccion_actual: "Adreça actual",
			direccion: "Adreça",
			iban: "Núm compte IBAN",
			seguridad_social: "Núm Seguretat Social",
			pais_nacionalidad: "País de nacionalitat",
			pais_segunda_nacionalidad: "País de segona nacionalitat",
			provincia_nacimiento: "Província de naixement",
			provincia: "Província",
			lugar_nacimiento: "Lloc de naixement",
			discapacidad: "Discapacitat superior al 33%",
			deseo_recibir_comunicaciones: "Vull rebre comunicacions relacionades amb orientació i serveis relacionats amb la formació superior i la UIB:",
			nombre: "Nom",
			primer_apellido: "Primer cognom",
			segundo_apellido: "Segon cognom",
			tipo_identificacion: "Tipus d'identificació",
			documento_identidad: "Document d'identitat",
			buscar: "Escriviu per cercar",
			cp: "Codi postal",
			pais: "País",
			localidad: "Localitat",
			tipo_via: "Tipus de via",
			numero: "Número",
			piso: "Pis",
			puerta: "Porta",
			notas: "Notes",
			datos_academicos: "Dades acadèmiques",
			formacion_complementaria: "Formació complementària",
			anadir_titulacion: "Afegir nova titulació",
			complementaria: "Complementària",
			centro: "Centre",
			tipo: "Tipus",
			nota: "Nota",
			rama_ensenanza: "Branca de l'ensenyament",
			duracion: "Durada",
			actual: "Actual",
			si: "Sí",
			no: "No",
			titulo: "Títol",
			universidad: "Universitat/Lloc d'estudis",
			calificacion: "Qualificació",
			calificacion_media: "Qualificació mitjana del títol",
			horas: "Hores",
			ambito: "Àmbit d'ensenyament",
			selecciona_tipo: "- Selecciona un tipus - ",
			certificacion: "Certificació",
			tienes_cerfificacion: "Tens certificació?",
			competencias_profesionales: "Competències professionals",
			tus_competencias: "Les vostres competències",
			sin_competencias: "Sense competències professionals especificades",
			solicitar_sesion: "Necessites ajuda per emplenar aquest apartat? Pots sol·licitar una sessió gratuïta d'orientació amb nosaltres fent clic a <a href='https://content.fueib.org/orientacio' target='_blank'>aquest enllaç</a> i t'ajudarem.",
			datos_interes: "Dades d'interès",
			busqueda_activa_practicas: "Cerca activa de pràctiques",
			busqueda_activa_empleo: "Cerca activa d'ocupació",
			disponible_extranjero: "Disponible per treballar a l'estranger",
			permiso_conducir: "Permís de conduir",
			disponible_cambio_residencia: "Disponible per canviar de residència",
			coche_propio: "Cotxe propi",
			disponible_viajar: "Disponible per viatjar",
			discapacidad_certificada: "Discapacitat certificada",
			carnet_moto: "Carnet de moto",
			moto_propia: "Moto pròpia",
			disponibilidad_jornadas: "Disponibilitat de jornades",
			periodo_preferencia_practicas: "Període de preferència de les pràctiques",
			selecciona: "Selecciona",
			anadir_documento: "Afegir documento",
			anadir_idioma: "Afegir idioma",
			anadir_intereses: 'Afegir interessos',
			nivel_academico: "Nivell acadèmic",
			nuevos_datos_academicos: "Noves dades acadèmiques"
		},
		addtitulacion: {
			titulo: "Titulacions a les quals s'adreça l'oferta",
			seleccione_areas: "Seleccionau l'àrea / le àrees per filtrar titulacions",
			borrar_areas: "Esborra totes les àrees",
			cualquier_area: "Qualsevol àrea",
			escriba_aqui: "Escriviu aquí per filtrar la llista de titulacions a continuació",
			selecciona_titulacion: "Seleccione la titulación/es a la/s que se dirige la oferta haciendo clic sobre ella/s",
			ver_titulaciones: "Veure titulacions de grau",
			llistades: "llistades",
			llistats: "llistats",
			cualquier_titulacion: "Qualsevol d'aquestes titulacions de grau",
			ver_titulaciones_postgrado: "Veure titulacions de postgrau",
			cualquier_titulacion_postgrado: "Qualsevol d'aquestes titulacions de postgrau",
			ver_titulaciones_propio: "Veure titulacions de títol propi",
			cualquier_titulacion_propio: "Qualsevol d'aquests títols propis",
			lo_sentimos: "Ens sap greu, no s'han trobat titulacions que coincideixin amb la cerca",
			listado_titulaciones_seleccionadas: "Llista de titulacions seleccionades",
			eliminar_titulaciones: "Elimina totes les titulacions seleccionades"
		},
		candidato: {
			nuevo: "Nou",
			cambiar_estado: "Canviar estat",
			ver_cv: "Veure CV",
			detalles: "Detalls del candidat/a",
			selecciona_estado: "Seleccionau un estat",
			seleccione_motivo: "Per favor, Seleccionau el motiu de rebuig del candidat/a",
			cambio_estado: "Canvi d'estat",
			descargar_cv: "Descarregar CV",
			cumplimentar_formulario_incorporacion: "Cumplimentar Formulario de Incorporación",
			pendiente_form_incorporacion: "Pendiente formulario de incorporación"

		},
		cambio_practicas: {
			identifica: "Identifica l'alumne/a del qual sol·liciten realitzar pròrroga o variació de les condicions de pràctiques",
			alumno: "Alumne/a",
			selecciona_oferta: "Selecciona l'oferta",
			no_practicas: "Encara no tens cap pràctica sobre la qual puguis sol·licitar un canvi",
			alumno: "Alumne/a",
			selecciona_alumno: "Selecciona l'alumne/a",
			detalles: "Detalls de la modificació",
			tipo_modificacion: "Tipus de modificació",
			selecciona_modificacion: "-Selecciona la modificació-",
			otros_detalles: "Altres detalls",
			adjunto: "Adjunt",
			solicitar_cambio: "Sol·licita canvi"
		},
		popup_idioma: {
			titulo: "Canviaràs la teva preferència d'idioma. Vols continuar?",
		},
		noticia: "Noticia",
		recurso: "Recurso",
		novedad: "Novedad"
	},
	en: {
		guardar: "Save",
		volver: "< Back",
		sin_definir: "Undefined",
		guardar_datos: "Save Data",
		cancelar: "Cancel",
		confirmar: "Confirm",
		eliminar: "Delete",
		aceptar: "Accept",
		rechazar: "Deny",
		comenzar: "Start",
		cerrar_sesion: "Log out",
		manual_uso: "User Guide",
		ver_menos: "Show less",
		ver_mas: "See more",
		ver_todas: "View all",
		inicio: "Home",
		ver_detalles: "View details",
		editar: "Edit",
		anadir: "Add",
		enviar: "Submit",
		requerido: "Required",
		revisar: "Review",
		editar_oferta: "Edit offer",
		duplicar_oferta: "Duplicate offer",
		cerrar_oferta: "Close offer",
		eliminar_oferta: "Delete offer",
		ver_como_candidato: "View as applicant",
		practicas: "Internships",
		empleo: "Employment",
		ver: "View",
		enlaces: {
			politica_privacidad: "/politica-de-privacidad",
			politica_cookies: "/politica-de-cookies",
			login: "/login",
			solicitar_cuenta: "/solicitar-cuenta",
			registroalumno: "/registro",
			encuestas: '/encuestas',
			encuesta: '/encuesta',
			eventos: '/eventos',
			eventospublico: '/evento-publico',
			documentacion: '/documentacion',
			guiaOrientacion: '/guias-orientacion',
			ofertas_practicas: '/ofertas-practicas',
			ofertas_empleo: '/ofertas-empleo',
			cv: '/cv',
			vercv: '/ver-cv',
			mis_candidaturas: '/mis-candidaturas',
			mis_practicas: '/mis-practicas',
			orientacion: '/orientacion-laboral',
			propuesta_practicas: '/propuesta-practicas',
			programapracticasactivos: '/programas-practicas-activos',
			solicitarcambiopracticas: '/solicitar-cambio-practicas',
			subirconvenio: '/subir-convenio-firmado',
			generarnuevoconvenio: '/nuevo-convenio-colaboracion',
			practicaseducacion: '/solicitudes-practicas-educacion',
			nueva_oferta: '/nueva-oferta',
			editar_oferta: '/editar-oferta',
			mi_empresa: '/mi-empresa',
			mi_perfil: '/mi-perfil',
			mis_ofertas: '/mis-ofertas',
			mi_oferta: '/oferta',
			programa_practicas: '/programa-practicas',
			visualizar_oferta: '/visor-oferta',
			restablecer_login: '/restablecer-login',
			restablecer_candidato: '/restablecer-candidato',
			setear_pass: '/establecer-login',
			proteccion_datos: '/proteccion-de-datos',
			acceso_saml: '/acceso',
			logout: '/logout',
			ayuda: '/ayuda',
			condicionespracticasuib: '/uib/condiciones-practicas',
			formulario_datos: '/formulario-datos',
			actualidad: '/actualidad',
			recursos: '/recursos'
		},
		encabezado: {
			home: "Welcome",
			cv: " My Resume",
			cv_view: "Candidate  Resume",
			eventos: "Events",
			propuesta_practicas: "Internship proposal",
			politica_privacidad: "Privacy Policy",
			politica_cookies: "Cookies Policy",
			login: "Log in",
			solicitar_cuenta: "New Company",
			registro_alumno: "Sing-up",
			ofertas_practicas: "List of Internship Offers",
			ofertas_empleo: "List of Job Offers",
			ficha_oferta_alumno_empleo: "List of Job Offers",
			ficha_oferta_alumno_practicas: "List of Internship Offers",
			mis_candidaturas: "My applications",
			actualidad: "News",
			recursos: "Resources",
			mis_practicas: "My internships",
			encuestas: "Surveys",
			orientacion: "Career Guidance",
			nueva_oferta: "New Offer",
			editar_oferta: "Edit Offer",
			mi_empresa: "My Company",
			mi_perfil: "My profile",
			documentacion: "Documentation",
			guiasOrientacion: "Orientation Guides",
			documentacion_empresa: "Company Documentation",
			documentacion_alumno: "My Documentation",
			mis_ofertas: "My offers",
			mi_oferta: "My Offer",
			ficha_oferta_empresa: "My Offer",
			restablecer_login: "Reset password",
			restablecer_candidato: "Reset password",
			programapracticasactivos: "Active Internship Programmes",
			setear_pass: "Create password",
			proteccion_datos: "Data protection",
			visor_oferta: "View as a student",
			fichaProgramaActivo: "Ongoing Programmes",
			solicitudCambioPracticas: "Internship change request",
			solicitudesEducacion: "Applications for educational offers",
			subirConvenioFirmado: "Upload signed agreement",
			generarNuevoConvenio: "New collaboration Agreement",
			ayuda: "Help",
			condicionespracticasuib: "Internship Conditions",
			info_alumno: "Important:If you plan to do an Internship until December 31, do not request your degree before that date.Requesting it earlier means losing student status and you won´t be able to continue the internship.",
			formulario_datos: "Data form",
			formulario_incorporacion: "Registration form",
			falta_num_ss: "Due to Royal Decree-Law 2/2023 effective January 1 2024,it is mandatory to provide your Social Security number and attach a copy. ",
			noticias: 'News',
			novedades: 'Updates',
			no_actualidad: 'No news to show',
			ver_fichero: 'View file'
		},
		proteccion_datos: {
			titulo: "ADDITIONAL INFORMATION ON DATA PROTECTION:",
			estudiantes: {
				p1: "We inform you that the controller responsible for your personal data is Universidad COLEGIO UNIVERSITARIO DE ESTUDIOS FINANCIEROS (hereinafter, CUNEF), Tax ID B-86969235, with its address for notification purposes at Calle C/ Leonardo Prieto Castro 2, 28040 – Madrid. CUNEF has appointed a Data Protection Officer who can be contacted at dpd@piconyasociados.es.",
				p2: "The personal data you provide when completing the forms will be processed in order to create and maintain your account to access the platform (including the possible sending of communications related to the platform, such as information about internships offered by companies, confirmation of enrolment in offers or changes in the status of applications) and to manage internships and your enrolment in the published job offers. The legal basis of the processing is your consent, which you may withdraw at any time. Withdrawal of consent will not affect the performance of your contract as a CUNEF student, and the processing carried out beforehand will remain lawful. The categories of data processed on the basis of consent are: identification and contact data, personal characteristics data, academic and professional data, data regarding hobbies or interests, where appropriate, as well as any other data you provide to the platform. Authorising the processing of your data for this purpose is voluntary; if you decline, you will not be able to enrol in internships or receive information about them.",
				p3: "The data provided may be communicated to different companies offering internships and/or employment with which CUNEF has educational cooperation agreements, solely for the purpose of reviewing your application and, where appropriate, initiating the selection process.",
				p4: "Data will be stored for as long as you remain a student of the University or until you withdraw your consent, as applicable.",
				p5: "In compliance with Regulation (EU) 2016/679, Organic Law 3/2018 of 5 December on the Protection of Personal Data and Guarantee of Digital Rights, and the remaining applicable regulations, we inform you that you have the right to access, rectify and erase data, limit processing, object to processing and exercise your right to data portability, all free of charge, by sending a written request to Universidad CUNEF – lopd@cunef.edu.",
				p6: "If you consider that your rights have been infringed, especially when you have not obtained satisfaction in exercising them, you may file a complaint with the Spanish Data Protection Agency (contact details available at www.agpd.es), either through its electronic headquarters or at its offices located at Calle Jorge Juan, nº 6, 28001 Madrid."
			},
			empresas: {
				p1: "We inform you that the controller responsible for your personal data is Universidad COLEGIO UNIVERSITARIO DE ESTUDIOS FINANCIEROS (hereinafter, CUNEF), Tax ID B-86969235, with its address for notification purposes at Calle C/ Leonardo Prieto Castro 2, 28040 – Madrid. CUNEF has appointed a Data Protection Officer who can be contacted at dpd@piconyasociados.es.",
				p2: "The personal data you provide will be processed in order to create an account to access the platform and to manage its maintenance. The legal basis is the performance of a contract to which the data subject is party. Providing the data is obligatory; otherwise, the purpose of the contract cannot be fulfilled.",
				p3: "Data will be retained for the time necessary to fulfil the purpose for which it was collected and, thereafter, for the limitation periods of any possible legal liabilities. Once those periods have elapsed, the data will be deleted.",
				p4: "Data will not be disclosed to third parties, except to public administrations in the cases provided for by law and to students when necessary for the management of internships or the training offered.",
				p5: "In compliance with Regulation (EU) 2016/679, Organic Law 3/2018 of 5 December on the Protection of Personal Data and Guarantee of Digital Rights, and the remaining applicable regulations, we inform you that you have the right to access, rectify and erase data, limit processing, object to processing and exercise your right to data portability, all free of charge, by sending a written request to Universidad CUNEF – lopd@cunef.edu.",
				p6: "If you consider that your rights have been infringed, especially when you have not obtained satisfaction in exercising them, you may file a complaint with the Spanish Data Protection Agency (contact details available at www.agpd.es), either through its electronic headquarters or at its offices located at Calle Jorge Juan, nº 6, 28001 Madrid."
			}
		},
		ficha_oferta: {
			texto_programa_anadido: "You have this programme added to your list of software programmes"
		},
		formulario: {
			nombre: "Name ",
			nombre_apellidos: "First name and last name ",
			apellidos: "Last name",
			email: "Email address",
			mensaje: "Message",
			fecha_nacimiento: "Date of birth",
			dia: "Day",
			mes: "Month",
			anyo: "Year",
			area_interes: "Area of your interest",
			trabaja_actualmente: "¿Are you currently working?",
			si: "Yes",
			no: "No",
			carta_presentacion: "Cover Letter",
			meses: {
				Enero: "January",
				Febrero: "February",
				Marzo: "March",
				Abril: "April",
				Mayo: "May",
				Junio: "June",
				Julio: "July",
				Agosto: "August",
				Septiembre: "September",
				Octubre: "October",
				Noviembre: "November",
				Diciembre: "December"
			},
			archivo_adjunto: "Attach file",
			adjuntar_cv: "Attach Resume",
			introduce_mail: "Enter your Email",
			pais: "Country",
			telefono: "Phone number",
			he_leido: "I have read and accepted the",
			y_acepto: "Privacy Policy",
			enviar: "Submit",
			enviado: "Submitted"
		},
		meses: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
		login: {
			iniciar_sesion: "Log in",
			acceder: "Access",
			email: "Email Address",
			error_mail: "Please enter your email to log in to the portal",
			contrasena: "Password",
			repetir_contrasena: "Reset password",
			contrasena_olvidada: "Forgot my password",
			introduce_email: "Enter your Email",
			email_mal: "The email format is not valid",
			recuperar_pass: "Reset my password",
			aun_no_registrado: "Haven´t registered yet?",
			acceder_SSO: "ENTER SSO UNIVERSITY PORTAL",
			indica_mail: "Please enter your email to log in to the portal .",
			selecciona_empresa: "Please select the Company you want to log in with.",
			titulacion: "Degree",
			tipo_formacion: "Education level",
			selecciona_formacion: "Select your education level",
			registrarme: "Register",
			deseo_recibir: "I wish to receive information and guidance related to higher education and services offered by the UIB.",
			popup_rgpd: {
				titulo: "Additional information",
				detalle: "You can find more detailed information about Data Protection at this ",
				enlace: "link.",
				boton: "I Consent, access",
				acepto: 'I have read and agree to the information on data protection'
			},
			restablecer_pass: {
				titulo: "Folow the steps to create your password ",
				intro: "Password must contain at least 8 characters and one number",
				guardar: "Save"
			},
			seteo_pass: {
				titulo: "Follow the steps to set your password",
				intro: "Password must contain at least 8 characters and one number.",
				guardar: "Save"
			}
		},
		registro: {
			encabezado: "Complete the form below to register in the system",
			datos_usuario: "Company user information",
			datos_personales: "Personal Information",
			nombre: "First name ",
			apellidos: "Last name",
			DNI: "DNI/NIF/NIE  ",
			CIF: "Company Tax ID",
			puesto: "Position/Job title",
			departamento: "Department",
			telefono_1: "Phone number",
			telefono_2: "Alternate phone number",
			email: "Email Address",
			sede: "Default Location",
			cargo: "Job title",
			idioma: "Preferred language",
			tipo_contacto: "Contact Type",
			contrasena: "Password",
			repetir_contrasena: "Confirm Password",
			direccion: "Address",
			pais: "Country",
			selecciona_pais: "Select a Country",
			provincia: "State",
			selecciona_provincia: "Select a State",
			localidad: "City",
			selecciona_localidad: "Select a city",
			direccion_empresa: "Company Address",
			cp: "Postal code",
			titulo_2: "Enter your Company details below to register in the system",
			anadir_imagen: "Click to add image",
			autorizar_logo: "Authorization for Logo Use",
			nombre_fiscal: "Legal name",
			nombre_comercial: "Business Name",
			tipo_sociedad: "Type of Business",
			selecciona_tipo_sociedad: "Select Business Type",
			tipo_empresa: "Business Type",
			privada: "Private",
			publica: "Public",
			startup: "Startup",
			eliminar: "Delete",
			descripcion: "Description",
			si: "Yes",
			no: "No",
			sector: "Sector",
			selecciona_sector: "Select a sector",
			otro_sector: "Other Sector",
			numero_empleados: "Number of employees",
			selecciona_empleados: "Select a range",
			web: "Web",
			iban: "IBAN account number",
			descripcion_empresa: "Company description",
			femenino: "Female",
			masculino: "Male",
			telefono: "Phone number",
			firmante: {
				titulo: "Enter the details of the Company´s legal representative who will sign the agreements",
				nombre: "Name of signer",
				apellidos: "Signer last name",
				email: "Signer  email",
				dni: "Signer ID number",
				cargo: "Signer Position",
				telefono: "Phone number"
			},
			contacto: {
				nombre: "Contact first name",
				apellidos: "Contact last name ",
				email: "Contact email",
				telefono: "Phone number"
			},
			delegado_proteccion_datos: {
				titulo: "Contact details of the DPO(Data Protection Officer)",
				nombre: "First Name",
				apellidos: "Last name",
				email: "Email Address",
				telefono: "Phone number"
			},
			envio_facturas: {
				titulo: "Invoice postal address",
				titulo_2: "Billing address"
			},
			anadir_direccion: "Add new billing address",
			perfil_sectorial: "Sector profile",
			sector_actividad: "Business sector",
			selecciona_sector_actividad: "Select a sector",
			rango: "Revenue Range",
			selecciona_rango: "Select a Range",
			selecciona_numero_empleados: "Select a Range",
			anyo_fundacion: "Year Founded",
			politica_1: "I read and agree to ",
			politica_2: "The privacy policy",
			popup_proteccion: {
				titulo: "BASIC INFORMATION ABOUT DATA PROTECTION",
				intro: "Please review the following privacy information before providing your personal data:",
				responsable_label: "Controller:",
				responsable_text: "COLEGIO UNIVERSITARIO DE ESTUDIOS FINANCIEROS (CUNEF).",
				finalidad_label: "Purpose:",
				finalidad_text: "To create and maintain an account that grants access to the platform.",
				derechos_label: "Rights:",
				derechos_text: "Under the legal terms, you may access, rectify, and erase your data, request restriction of processing, object to processing, and request data portability.",
				informacion_adicional_label: "Additional information:",
				informacion_adicional_text: "You can review further and detailed information about Data Protection at this",
				informacion_adicional_link: "link"
			},
			nuevo_contacto_titulo: "New management contact Information",
			anadir_contacto: "Add contact",
			nueva_cuenta_fiscal: "New tax account information",
			domicilio_fiscal: "Tax Address",
			poblacion: "City",
			requiere_envio_postal: "Requires postal invoice delivery",
			domicilio_postal: "Postal address for invoices",
			anadir_cuenta: "Add account",
			datos_firmante: "Signer information",
			area_conocimiento: "Area of Knowledge",
			nombre_titulacion: "Name of the degree",
			ano_inicio: "Start year",
			ano_finalizacion: "End  year",
			solicitar_cuenta: "Request an account",
			seguir_empresa: "Continue with company information",
			registrar_empresa: "Register Company",
			dni_pasaporte_nie: "DNI/NIF/NIE/Passport",
			selecciona_nivel: "Select a level",
			busca_area: "Select your area",
			busca_titulacion: "Select your degree",
			firmaDigital: "SignatureType for Agreement",
			asume_coste_SS: "Does your entity agree to assume the responsibility for fulfilling,managing and covering the costs of Social Security obligations for students undertaking training placements or external academic internships at your organization,as established in Royal Decree-Law 2/23?",
			asume_coste_SS_Si: "Yes,we agree to assume the responsibility for fulfilling,managing and covering the costs of the student´s  Social security obligations,at the time they  become effectively applicable,as established in Royal Decree-Law 2/2023",
			asume_coste_SS_No: "No,we do not accept.We request that CUNEF assumes the responsibility for fulfilling,managing and covering the cost of the student´s  Social  Security obligations at the time they become effectively applicable,as established in Royal Decree-Law 2/2023"
		},
		home_empresa: {
			ofertas_practicas: "<strong>Internship</strong> Opportunities",
			texto_ofertas_practicas: "Browse and manage available internship opportunities and received applications.",
			nueva_practicas: "Post <strong>New internship Opportunity</strong>",
			publicar_practicas: "Post internship opportunities targeted at our students.",
			nueva_propuesta: "Apply for <strong>Internship proposal</strong>",
			publicar_propuesta: "If you do not want to publish an offer for all our students but have already selected the student who will carry out the internship, you can submit your internship proposal for that student here.",
			ofertas_empleo: "<strong>Job</strong> Opportunities",
			texto_ofertas_empleo: "Review and manage job offers and received applications.",
			nueva_empleo: "Post new <strong>Job Offer</strong>",
			texto_nueva_empleo: "Post job offers for candidates with up to 3 years of experience."
		},
		mi_practica: {
			subir_documentacion: "Upload Files",
			descargar_anexo: "Download signed Annex",
			descargar_certificado: "Download Internship Completion Certificate",
			descargar_poliza: "Download Insurance Policy",
			titulo_practicas: "To be able to participate in these internships,it is necessary to:",
			pagar_creditos: "Pay the credits that will be recognized.",
			descarga: "Download",
			aqui: "Here",
			documento_pago: "The Payment Letter document containing the information on amounts owed and instructions .",
			contratar_poliza: "Purchase an accident insurance policy that covers your internship",
			puedes_contratar: "You can choose any insurance policy.If you prefer,you can purchase one online",
			mensaje_documentos: "Once your documents are ready ,please digitize and upload them below.We will verify their validity before signing the agreement with the company.",
			digitaliza_documentos: "Once the document is ready ,please digitize and upload it below.We will verify its validity before signing the agreement with the company.",
			adjuntar_pago: "Attach proof of payment",
			adjuntar_seguro: "Attach insurance policy",
			descarga_ficheros: "Download the following files,signed them and upload the signed version.",
			enviar: "Submit",
			renuncia_practicas_SET: "These extracurricular internships will be recorded in your Diploma Supplement (SET-European Diploma Supplement) if you meet the legal requirements. If you do not wish them to be included in the SET, you must attach a signed waiver document. You can download the template here.",
			adjuntar_renuncia: "Attach signed resignation letter",
			tutor_academico: "Academic tutor:",
			calificacion: "Grade:",
			anexos_7: "Annex 7",
			observaciones_tutor: "Tutor comments:",
			documento_renuncia: "Resignation document",
			nuevo_anexo_7: "New Annex 7",
			adjuntar: "Attach"
		},
		mis_practicas: {
			titulo: "In this section you will find all the documentation related to your internship.",
			zero_1: "No internship opportunities or related documents are currently available for display.",
			gracias: "Thank you very much.",
			emailJuridica: "practicas.derecho@comillas.edu  ",
			emailIngenieria: "practicas.ingenieria@comillas.edu  ",
			emailEconomica: "practicas.ade.ibs@comillas.edu  ",
			emailSanitaria: "practicas.soci.sani@comillas.edu  ",
			emailEducacion: "mvtorres@comillas.edu  ",
			emailRRII: "practicas.ri.com.ti@comillas.edu  ",
			emailInternacional: "jrmunoz@comillas.edu  "
		},
		cambio_password: {
			titulo: "Change password",
			titulo_candidato: "Do you want to change your password?",
			contrasena_actual: "Current password",
			nueva_contrasena: "New password",
			repetir_contrasena: "Confirm new password"
		},
		guia_orientacion: {
			titulo: "Below ,we provide documents related to your internship or employment,as well as tips and best practices that may be of your interest.",
			zero: "No orientation guides are currently available"
		},
		mi_empresa: {
			intro: {
				cuerpo: "The key information regarding your company is displayed below.",
				porfavor: "If you have any questions please,",
				contacte: "do not hesitate to contact us."
			},
			datos_empresa: "Company details"
		},
		formulario_datos: {
			intro: {
				cuerpo: "The main details of your company are shown below.please update or complete the following information about your company.",
				porfavor: "Please ",
				contacte: "contact us"
			},
			datos_empresa: "Company details",
			datos_firmante: "Signer information",
			datos_contacto: "Contact information"
		},
		propuesta_practicas_form: {
			intro: {
				instructions: "If you have found a company where you can complete your curricular or extracurricular internship, you can register it here. We will review it and approve it if it meets all the required criteria.",
				pdf_description: "Summary sheet to gather the information needed to submit the internship proposal through this form.",
				unknown_data: "If you are missing any data, please enter 'unknown'.",
				education_info: "If you are studying the Master's Degree in Teacher Training for Secondary Education, Baccalaureate, Vocational Training or Language Teaching, you can request an educational centre for your internship, whether or not you already have a confirmed placement."
			},
			actions: {
				download: "Download"
			},
			steps: {
				academics_title: "Academic information",
				company_title: "Company information",
				contact_title: "Company contact information",
				step_indicator: "Step {current} of {total}"
			},
			labels: {
				select_degree: "Select a degree*",
				course: "Academic year*",
				cif: "Company tax ID (CIF) or personal tax ID (NIF)*",
				school_certificate: "School certificate",
				employment_record: "Employment record",
				select_school_center: "Select the educational centre:",
				company_name: "Company name",
				company_cif: "Company tax ID",
				workplace_data: "Workplace details",
				locality: "Town/City*",
				postal_code_short: "Postcode*",
				trade_name: "Trade name*",
				legal_name: "Registered name*",
				website: "Website",
				company_phone: "Company phone 1*",
				company_email: "Company email*",
				address: "Address*",
				postal_code: "Postcode*",
				signatory_name: "Signatory name",
				signatory_surnames: "Signatory last name(s)",
				signatory_email: "Signatory email",
				signatory_dni: "Signatory ID",
				signatory_role: "Signatory position",
				contact_name: "Contact name",
				contact_email: "Contact email",
				contact_role: "Position / Role*",
				contact_phone: "Phone 1"
			},
			placeholders: {
				select_degree: "Click to choose a degree",
				school_center: "Educational centre",
				select_sector: "-Select a sector-",
				select_country: "-Select a country-",
				select_province: "-Select a province-",
				select_town: "-Select a town-"
			},
			questions: {
				practice_type: "What type of internship are you proposing/requesting?*",
				education_request: "Are you submitting this request for an Education and Teacher Training degree?*",
				confirmed_place: "Do you already have a confirmed placement?"
			},
			options: {
				curricular: "Curricular",
				extracurricular: "Extracurricular",
				yes: "Yes",
				no: "No",
				confirmed_place_yes: "Yes, I already have a confirmed placement at an educational centre",
				confirmed_place_no: "No, I would like to propose a centre of my choice for the internship."
			},
			messages: {
				attention: "Attention!",
				no_confirmed_place_info: "Only if you do not yet have a confirmed placement at an educational centre.",
				remaining_requests: "You still have {count} centre requests remaining.",
				wait_for_confirmation: "Attention! You must wait for the university confirmation before your internship is officially approved. Your request will be processed and you will receive the resolution through the campus messaging system.",
				enter_cif: "Enter the tax ID (CIF) of the company where you will complete the internship.",
				select_center: "Select the centre where the internship will take place. Search by province and name:",
				loading: "Loading...",
				no_companies: "No companies found",
				review_company: "Check that the company details match the company where you will do the internship. If you have any questions or notice an error, email us at",
				company_not_found: "The provided tax ID does not exist in our database. Please fill in the fields below.",
				enter_contact_email: "Enter your company contact's email.",
				review_contact: "Verify that the company details match the contact's details. If you have any questions or notice an error, email us at",
				contact_not_found: "We do not have this contact in our database. Please complete the details.",
				signatory_intro: "Please enter the details of the legal representative who will sign the agreements:",
				review_fields: "Please review all fields to continue."
			},
			buttons: {
				validate_company: "Validate company",
				validate_contact: "Validate contact"
			},
		links: {
			company_not_found: "I can't find the company"
		}
	},
		propuesta_practicas_empresa: {
			intro: "If a student is going to complete an internship at your company, you can enter all the details here. We will review and formalize your proposal if both the internship opportunity and the selected candidate meet the required criteria.",
			instructions_text: "You can review the internship proposal instructions ",
			instructions_link: "here",
			student_data_title: "Student details",
			select_program_option: "Select an internship program",
			program_requirements: "Remember to review the requirements for this program before creating the internship offer. You can check all the details ",
			program_requirements_link: "here",
			enter_dni: "Enter the candidate's ID number.",
			dni_label: "DNI/NIE/Passport*",
			validate_candidate: "Validate candidate",
			verify_candidate_data: "Make sure the candidate's details match. If you have any questions or notice an error, email us at",
			candidate_name_label: "Candidate name",
			candidate_degree_label: "Candidate's degree*",
			candidate_degree_placeholder: "Enter the student's degree"
		},
		candidaturas_options: {
			aceptar: "Confirm registration",
			rechazar: "Reject registration",
			motivos_rechazo: "Rejection reasons",
			selecciona_motivo: "please select a reason for rejection",
			rechazar_preinscripcion: "Decline pre-registration"
		},
		oferta: {
			intro_editor: "Please complete the form below to create a new offer",
			tipo_oferta: "Type of position",
			numero_plazas: "Number of positions",
			experiencia: "Experience",
			experiencia_deseable: "Preferred experience",
			horario: "Working hours",
			fecha_inicio: "Start day",
			fecha_fin: "End day",
			tipo_contrato: "Contract type",
			salario: "Salary",
			creditos: "Credits passed/Credits completed",
			otras_remuneraciones: "Other benefits",
			pais: "Country",
			poblacion: "State",
			poblacion_only: "City",
			provincia: "State",
			sector: "Sectors",
			area_funcional: "Functional Area",
			sede: "Campus",
			beca: "Monthly grant",
			descripcion_puesto: "Job description",
			tarea: "Task",
			tutores_disponibles: "Available tutors",
			otras_tareas: "Other tasks",
			programa_practicas: "Internship programme",
			aviso_programa: "Important: verify mandatory requirements",
			enlace_inscripcion: "Registration link",
			ir_enlace: "Click the link",
			idiomas: "Languages",
			anadir_idiomas: "Add languages",
			empleo: "Jobs",
			practicas: "Internships",
			certificacion: "Minimun certification required",
			requerido: "Required",
			estudios_obligatorios: "Compulsory studies",
			estudios_deseables: "Preferred studies",
			estudios_propuestos: "proposed courses",
			requisitos_obligatorios: "Mandatory requirements",
			etiquetas: "Tags",
			otros_obligatorios: "Additional mandatory requirements",
			edad_maxima: "Maximum age",
			salario_maximo: "Maximun salary",
			intereses_deseables: "Preferred interests",
			intereses_obligatorios: "Mandatory interests",
			intereses_seleccionados: "Selected interests",
			competencias_obligatorias: "Mandatory competencies",
			competencias_seleccionadas: "Selected competencies",
			paises_nacionalidad_obigatorios: "Mandatory countries of nationality",
			paises_residencia_obligatorios: "Mandatory countries of residence",
			provincia_residencia_obligatorios: "Mandatory province of residence",
			paises_seleccionados: "Selected countries",
			provincias_seleccionados: "Selected provinces",
			coche_propio: "Own vehicle",
			obligatorio_quest: "¿Mandatory?",
			carnet_conducir: "Driver´s license",
			disponible_extranjero: "Available to work abroad",
			disponible_residencia: "Open to relocation",
			trabajando_actualmente: "Currently employed/working",
			requisitos_deseables: "preferred requirements",
			otros_requisitos_deseables: "Other preferred requirements",
			otros_requisitos_obligatorios: "Other mandatory requirements",
			motivos_exclusion: "reasons for disqualification",
			competencias_deseables: "preferred qualifications",
			paises_nacionalidad_deseables: "Desired nationalities",
			paises_residencia_deseables: "Preferred countries of residence",
			provincia_residencia_deseables: "Preferred provinces of residence",
			programas_informaticos: "Software programmes",
			programas_informaticos_deseables: "Preferred Software",
			documentos_requeridos: "Required documents",
			documentos: "Documents",
			marca_documentos: "Please indicate which supporting documents besides the Resume, you would like the students to submit (e.g,cover letter,recommendation letter,etc). Kindly list each document separately.",
			categoria: "Category",
			marca_categoria: "Please indicate the category of the resource you wish to filter.",
			anadir_otro_documento: "Request candidate to submit documents",
			nombre_documento_candidato: "Name of the document to be submitted by the candidate",
			inscribirme: "Apply",
			desinscribirme: "Cancel",
			ya_inscrito: "You have already applied",
			cancelar_inscripcion: "Withdraw/cancel application",
			buscar_mas_intereses: "Explore more interests",
			atencion: "Attention!",
			tramitar_inscripcion: "To apply for this offer,please submit your application on the company´s  website.",
			info_adicional_facturacion: "Additional billing information",
			datos_firmante: "Signer details",
			nombre_firmante: "Signer name",
			apellidos_firmante: "Signer surname(s)",
			email_firmante: "Signer email",
			telefono_firmante: "Signer phone number",
			cargo_firmante: "Signer position",
			de_la_empresa: "of the company",
			CIF: "ID",
			selecciona_opcion: "-Select one-",
			acceder: "To access",
			pincha_aqui: "Click here",
			especialidad: "Specialty",
			estado: "Status",
			datos_practica: "Internship details",
			paso_4: "Step 4 of 4",
			tareas_a_desarrollar: "Tasks to be performed",
			horario: "Shedule",
			horario_practicas: "Internship schedule",
			idioma_realizacion_practica: "Internship language",
			horario_trabajo: "Working hours",
			tengo_candidato: "I have a candidate",
			horas_dia: "Hours per day",
			remuneracion: "Salary (€ gross/month)",
			otros_beneficios: "Other benefits",
			fechas_practica: "Internship  dates",
			especificar_fechas: "Specify dates",
			no_definidas: "Not defined",
			oncorporacion_inmediata: "Immediate start",
			fecha_alta: "Start  day/registration date",
			duracion_meses: "Duration (in months)",
			dedicacion: "Commitment (% of full-time)",
			departamento: "Department",
			modalidad: "Modality",
			numero_dias_semana: "Number of days per week",
			dias_semana: "days per week",
			vinculado_tfg: "Linked to Final Degree Project (FDP)",
			nombre_tfg: "FDP title",
			tutor_tfg: "Final Degreen Project tutor",
			solicitante: "Service requester",
			centro_practicas: "Internship  Location",
			n_pedido: "Order number (If required)",
			observaciones: "Additional Comments",
			direccion: "Address",
			nombre_tutor_uni: "Full name of the University tutor",
			datos_tutor_empresa: " Company supervisor details",
			nombre: "First name ",
			apellidos: "last name",
			email: "email address",
			telefono: "Phone number",
			cargo: "Position",
			dni: "DNI (National Identity Document)",
			titulacion_especialidad: "Degree or specialization",
			titulacion: "Degree/Job title",
			selecciona: "Select",
			nombre_oferta: "Offer title",
			experiencia_requerida: "Required Experience",
			experiencia_deseable: "Preferred Experience",
			opciones_publicacion: "Posting options",
			url_inscripcion: "Company Application URL",
			candidato_preferido: "Preferred Candidate",
			datos_realizacion: "Internship details",
			conocimientos_especificos: "Specific Knowledge",
			formacion_adquirida: "Adquired skills",
			seguimiento_previsto: "Planned Monitoring",
			empresa_destino: "Host company",
			datos_tutor: "Company supervisor details",
			para_estudiantes_ultimo_ano: "For final-year students",
			curso_minimo_requerido: "Minimum year required",
			para_perfil_no_universitario: "For non-university profiles",
			activo_quest: " Active?",
			ano_promo_maximo: "Maximum Graduation Year",
			enviar_quest: "Submit?",
			candidato_leer: "Unread Candidate ",
			candidatos_leer: "Unreads Candidates",
			candidato_total: "Total candidate",
			referencia: "Reference",
			candidatos_total: "Total candidates",
			ver_detalles: "View details",
			con_practicas: "- Intership Assigned",
			fecha_caducidad: "Expiration date",
			buscar_mas_programa: "Find more software ",
			programas_elegidos: "Selected Software programmes",
			sin_programas: "No software specified",
			selecciona_idioma: "Select a language",
			escribe_idioma: "Enter the language here",
			indica_certificacion: "Minimum Certification or Level required",
			titulaciones: "Degrees",
			requeridas: "Required",
			deseables: "Preferred",
			propuestas: "Suggested",
			a_las_que: "Targeted Degrees",
			nivel: "Level",
			areas: "Fields",
			cualquier_area: "Any Field",
			otros: "Other",
			ninguna_titulacion: "No degrees match the specified level filter.",
			eliminar_todas: "Delete all",
			areas_dirige: "Target Areas of the Offer",
			titulaciones_dirige: "Degrees targeted by the Offer",
			selecciona_titulaciones: "Select the degrees from the list on the left",
			cumplimentar: "Fill in only if you consider this information relevant for the students.",
			tipo_estudios: "Type of studies",
			seleccione_izquierda: "select the areas from the list on the left.",
			seleccione_algun_nivel: "select a level to load the associated areas",
			especialidad_titulacion: "Specialization or Degree",
			puesto_trabajo: "Job position",
			motivo_rechazo: "Reason for rejection",
			ayuda_estudio: "Study Grant",
			tutor_empresa: " Company Tutor",
			nombre_tutor: " Company Tutor first name",
			apellidos_tutor: "Company Tutor last name",
			email_tutor: "Company Tutor Email",
			telefono_tutor: "Company Tutor Phone",
			cargo_tutor: "Company Tutor Position",
			titulacion_tutor: "Company Tutor Degree",
			departamento_tutor: "Company Tutor Department",
			dni_tutor: "Company Tutor ID Number",
			no_definido: "Not defined",
			candidatos: "Candidates",
			exportar: "Export",
			no_hay_candidatos: "There are no candidates for this offer",
			mas: "more",
			menos: "less",
			empresa_destino_simple: "Destination company",
			tipo_formacion: "Formation type",
			niveles: "Levels",
			areas: "Areas",
			para_estudiantes_ultimo_curso: "For final-year students",
			duplicar_oferta_aviso: "Offer duplicated correctly Do you want to edit it now?",
			alumno_validado_uib: "Student validated by DOIP UIB",
			condicionespracticas: "I have read and agree to the terms and conditions. <a target='_blank' href='/uib/condiciones-practicas'>See conditions</a>",
			idioma: "Language",
			ofertacerrada: "A closed offer will not be visible and will not receive new candidates. Are you sure you want to close this offer?",
			eliminaroferta: "The offer is going to be deleted Do you want to continue?",
			ofertaduplicada: "Offer duplicated correctly Do you want to edit it now?",
			controlCerraroferta: "Has selected any of the candidates proposed by DOIP UIB?",
			cumplimentainformacion: "Please complete the following information:",
			nombrepersona: "Name and surname of the selected person",
			fechainiciocontrato: "Start date of the contract",
			tipocontrato: "Contract type",
			nota_media: "Average note",
			observaciones: "Observations",
			nombre_apellidos_dni: "Name, surname and DNI",
			ocultar_datos_empresa: 'Hide company data',
			url_informacion_complementaria: 'URL for complementary information',
			fichero_informacion_complementaria: 'Complementary information file:',
			ver_fichero_adjunto: 'View attached file:',
			datos_firmante: "Signer details",
			firmante: {
				nombre: "Signer name",
				apellidos: "Signer surname",
				email: "Signer email",
				dni: "Signer ID",
				cargo: "Signer position",
				telefono: "Signer phone number"
			},
		},
		filtro_oferta: {
			buscar_nombre: "Search by job title",
			buscar_localizacion: "Search by location",
			buscar_titulacion: "Search by degree",
			buscar_puesto: "Search by job title",
			filtro_avanzado: "Advanced filter",
			cerrar: "Close",
			fecha_publicacion: "Publication date",
			fecha_inicio_previsa: "Expected internship start date",
			fecha_inicio: "Start date",
			filtrado_etiqueta: "Filtered by tags",
			omitir_inscritos: "Skip already registered",
			oferta_tfg: "Bachelor´s/Master´s Thesis Offer",
			ofertas_internacional: "International Offer",
			ofertas_cv: "Offers that match my profile/resume",
			busquedas_guardadas: "Saved searches",
			guardar_busqueda: "Save search",
			borrar_filtros: "CLEAR FILTERS",
			ver: "View ",
			fecha: "Date",
			ofertas_tfg: "Bachelor´s/Master´s Thesis Offer",
			se_han_encontrado: "Results found",
			oferta_singular: "offer",
			oferta_plural: "offers",
			introduce_nombre_busqueda: "Enter the name of the search ",
			sobreescribe_existente: "or overwrite an existing one",
			selecciona_busqueda: "Select a search",
			ver_historico: "View offer history",
			ver_actuales: "View Current offers",
			crear_oferta: "CREATE OFFER",
			historico_ofertas: "Offer History",
			no_hay_ofertas: "No offers match your search",
			solo_con_candidatos: "Only offers with unread applicants",
			tienen_candidatos: "They have applicants",
			caduca_pronto: "Expiring soon",
			no_leidos: "Unread only",
			modalidad: "Mode",
			puesto_Empresa: "Position/Company",
			buscar_sector: "Search by sector"
		},
		popup_confirmacion: {
			recuerda: "Reminder!",
			titulo: "Make sure your profile information is up to date before applying for an offer.",
			actualiza: "Update it by clicking ",
			aqui: "here",
			confirma_titulo: "Please confirm that you want to apply for this offer.",
			atencion: "Please note",
			necesitamos_anadir: "You need to upload the following documents to apply for this offer",
			url_documento: "Document URL",
			por_favor_adjunta: "Please attach a file or provide a URL",
			alumnos_master: "Students enrolled in a 2 year master´s programme must have completed at least 50% of their credits by the internship start date in order to participate. Are you enrolled in a master´s program shorter than 2 years, or have you completed more than 50% of the credits?",
			inscripcion_externa: "The application for this offer must be completed through the company´s website.",
			confirma_inscripcion_externa: "Please confirm that you want to be redirected to the company´s website to apply  for this offer.",
			inscrito: "Registered",
			abrir_inscripcion_externa: "If you were not redirected to the company´s website, you can access it via this link",
			copiar_enlace: "Copy "
		},
		header: {
			hola: "Hello",
			oferta_practicas: "Search internship offers",
			oferta_empleo: "Search job offers",
			propuesta_practicas: "Internship proposal",
			candidaturas: "My applications",
			practicas: "My internships",
			programas: "Programmes",
			encuestas: "Surveys",
			eventos: "Events",
			mi_cv: "My Resume",
			guias_orientacion: "Orientation guides",
			mis_ofertas: "My offers",
			nueva_oferta: "New offer",
			solicitar_cambio_practicas: "Request Internship change",
			documentacion: "Documentation",
			solicitudes_practicas_educacion: "Internship requests education",
			mi_empresa: "My company",
			ayuda: "Help",
			cerrar_sesion: "Log out",
			manual_uso: "User guide",
			solicitar_baja: "Unsubscribe",
			formulario_datos: "Data form",
			recursos: "Resources",
			actualidad: "News"
		},
		image_uploader: {
			titulo: "Edit profile picture"
		},
		notificaciones: {
			borrar_todo: "Clear all",
			importantes: "Important",
			otras_notificaciones: "Other notifications",
			no_notificaciones: "You have no pending notifications"
		},
		popup_borrar_cuenta: {
			titulo: "Do you want to unsubscribe from the service and request the deletion of your personal data",
			si: "Yes",
			no: "No "
		},
		popup_faltan_datos_empresa: {
			atencion: "Please note",
			cuerpo_1: "Required information is missing in your profile. Please access it to complete the missing data.",
			cuerpo_2: "Required information is missing in your company´s profile. Please access it to complete the missing data.",
			ir_a_perfil: "Go to my profile",
			ir_a_empresa: "Go to my Company"
		},
		popup_datos_personales: {
			atencion: "Please note",
			titulo: "You need to provide your current phone number. You can do this in the My Profile > General Information section.",
			ir_a_perfil: "Go to my profile"
		},
		solicitudes_educacion: {
			titulo: "In this section,you will find information about students who have applied to do internships at your center.",
			zero: "There is currently no documentation available."
		},
		filtro_candidaturas: {
			buscar_nombre: "Search by job title",
			empleo: "Employment",
			practicas: "Internships",
			filtro_avanzado: "Advanced filter",
			cerrar: "Close",
			estado: "Status",
			ver: "View",
			borrar_filtros: "CLEAR FILTERS",
			estas_en: "You are in",
			proceso_seleccion: "selection process",
			procesos_seleccion: "selection processes",
			zero: "There are no selection processes matching your search."
		},
		documentacion: {
			intro: "In this section,you will find documentation related to the internships carried out at your company.",
			convenio_titulo: "Collaboration agreements",
			caducado: "(Expired)",
			zero_convenio: "You don´t have any agreements yet",
			titulo_convenio: "If you wish,you can request and download the collaboration agreement,or upload the document already signed by your company",
			nuevo_convenio: "New agreement",
			subir_convenio: "Upload signed agreement",
			anexos_practicas: "Internship  annexes",
			zero_practicas: "You don´t have any content yet",
			notas_formativas: "Formative Assessments",
			en: "in",
			otros_documentos: "Other documents related to internships",
			zero_documentos: "You don´t have any internship documents yet",
			otros_documentos_programas: "Other documents related to programmes",
			zero_documentos_practicas: "You don´t have any documents associated with the programmes yet",
			documentos_aportados_empresa: "Other documents provided by the company",
			no_documentos_anadidos: "No documents have been added. Click\"\"add document\"\"to upload one",
			anadir_documentacion: "add document",
			selecciona_documento: "Select a document",
			listado_documento: "Document list",
			otro_tipo_documento: "Other type of document",
			nombre_documento: "Document name",
			url_documento: "Document URL"
		},
		encuestas: {
			titulo: "Pending surveys",
			obligatorias: "To continue, please answer all required questions",
			enviar: "Submit",
			siguiente: "Next",
			empezar_de_nuevo: "Start Over",
			pagina: "Page",
			datos_enviados: "Your information has ben submitted",
			muchas_gracias: "Thank you very much! ",
			iniciar_sesion: "Log in with your profile user",
			empresa: "Company ",
			candidato: "Candidate",
			usuario: "Username",
			contrasena: "Password",
			acceder: "Log in",
			o: "or",
			acceder_anonimamente: "Log in anonymously",
			contestar_pregunta: "You must answer this question to continue",
			zero: "No surveys available",
			cuerpo: "Please complete these surveys before continuing",
			no_puedes: "You cannot access the portal until you have completed the pending surveys. If you do not wish to respond now, you may log out."
		},
		eventos: {
			proximos: "Upcoming events",
			pasados: "Past events",
			evento_destacado: "Featured event",
			desde: "From",
			hasta: "To",
			organizado_por: "Organized by",
			inscribirse: "Register",
			inscrito: "Registered",
			mas_informacion: "More information",
			galeria: "Image Gallery",
			videos: "Videos",
			buscar_localizacion: "Search by location",
			buscar_categoria: "Search by category",
			buscar_nombre: "Search by name",
			eventos_pasados: "Past events",
			ver_mas: "See more"
		},
		comunicaciones: {
			titulo: "Communications"
		},
		guias: {
			titulo: "Latest guidance materials",
			zero: "No guidence materials available"
		},
		ofertas: {
			ultimas_practicas: "Latest internship offers",
			practicas: "Internships",
			ultimas_empleo: "Latest job Offers",
			empleo: "Employment",
			ofertas: "Offers",
			zero_ofertas: "No offers available",
			contrato: "Contract",
			idContrato: "Contract",
			salario: "Salary",
			areaFuncional: "Functional Area",
			provincia: "Region",
			areasTitulaciones: "Degree Areas",
			nivelesTitulaciones: "Degree Levels",
			tiposFormacion: "Education Types",
			tituloPrograma: "Programme",
			area: "Area",
			filtrar_titulacion: "Filter by Degree",
			tipoModalidadAsistencia: "Attendance Mode"
		},
		cv: {
			nivel: "Level",
			programa_informatico: "Software Programme",
			certificado: "Certificate",
			sin_nivel: "Undefined Level",
			presentacion: "Introduction",
			anadir_presentacion: "To add your introduction, click",
			aqui: "here",
			otros_intereses: "Other interests",
			tus_interes: "Your interests",
			sin_intereses: "No interests specified",
			escribe_interes: "Enter an interest to start  searching",
			click_interes: "Click on the interest to add it",
			click_cambiar_imagen: "Click to change the image",
			cambiar_contrasena: "Change password",
			idiomas: "Languages",
			idioma: "Language",
			sin_idiomas: "No languages added. Click \"Add language\" to include one",
			idioma_obligatorio: "Language and proficiency level are required fields to add a language",
			nivel_no_definido: "Undefined Level",
			nombre_certificado: "Certificate name",
			estancia_extranjero: "Stay abroad",
			pais_estancia: "Host Country",
			motivo_estancia: "Reason for the stay",
			duracion_meses: "Duration in months",
			experiencia_profesional: "Professional experience",
			anadir_nueva_experiencia: "Add new experience",
			sin_experiencia: "No experience",
			nivel_formativo: "Educational level",
			actualidad: "Present",
			puesto: "Job title",
			anadir_documento: "Add document",
			sector_empresa: "Company sector",
			area_actividad_puesto: "Job activity area",
			tipo_contrato: "Contract type",
			subtipo_contrato: "Contract subtype",
			ver_adjunto: "View attachment",
			ver_enlace: "View link",
			duracion: "Duration",
			fecha_inicio: "Start date",
			fecha_fin: "End date",
			provincia: "Region",
			empresa: "Company",
			enlace: "Link",
			descripcion_puesto: "Job description",
			objetivo_profesional: "Career objective",
			escribe_descripcion: "Describe the tasks performed",
			anadir_fichero: "Add attachment",
			adjunto_correctamente: "Attachment uploaded successfully",
			isla: "Island",
			programas_informaticos: {
				titulo: "Software Programmes",
				buscar: "Type to search",
				zero: "No software programmes added",
				anadir: "Add programme"
			},
			sectores_interes: {
				titulo: "Sectors of interest",
				buscar: "Type to search",
				zero: "No sectors of interest added",
				anadir: "Add sectors of interest"
			},
			documentacion_adjunta: "Attached documentation",
			documentacion_subida: "Documentation uploaded on",
			no_hay_documentos: "No documents added",
			pulsa_anadir_documentos: "\"Click \"add document\" to include one",
			anadir_documentacion: "Add documentation",
			selecciona_documento: "Select a document",
			listado_documento: "Document list",
			otro_tipo_documento: "Other document type",
			nombre_documento: "Document name",
			url_documento: "Document URL",
			documentacion_privada: "Private documentation",
			no_documentos: "No documents added. Click \"Add document\" to include one.",
			documentacion_ligada: "Documentation linked to processes",
			estancias: "Stays",
			consentimientos_titulo: "Consents",
			consentimientos_intro: "Select the consents you authorise for your international stays.",
			consentimiento_imagen: "I authorise the publication of my image in CUNEF media",
			consentimiento_contactos: "I authorise sharing my contact details with future mobility students",
			consentimientos_guardados: "Consents saved",
			ver_documento: "View document",
			firmar: "Sign",
			firmado: "Signed",
			listado_estancias: "List of stays",
			no_estancias: "You have no stays.",
			datos_profesionales: "Professional data",
			visitar: "Visit",
			indica_link_perfil: "Provide a  link to your profile",
			trabajando_actualmente: "Currently working",
			permiso_trabajo: "Work permit for the EU",
			situacion_actual: "Current situation",
			ocupado: "Employed",
			desempleado: "Unemployed",
			con: "With",
			sin: "Without",
			anos_experiencia: "Years of experience",
			disfrutado_erasmus: "I have participated in Erasmus or another mobility grant",
			minima_retribucion: "Minimum salary",
			brutos_anuales: "/gross annual(salary)",
			datos_personales: "Personal information",
			dni: "DNI  ",
			fecha_nacimiento: "Date of birth",
			genero: "Gender",
			femenino: "Female",
			masculino: "Male",
			email_personal: "Personal email",
			email_estudiante: "Student email",
			avisos_en_email: "Notifications to personal email",
			acepta_newsletter: "Subscribe to newsletter",
			idioma_comunicaciones: "Preferred language for communications",
			movil: "Mobile phone",
			fijo: "Other phone",
			telefono_contacto: "Contact phone",
			telefono_contacto_placeholder: "E.g. 600123456 or +33 612345678",
			direccion_empadronamiento: "Registered address",
			direccion_actual: "Current address",
			direccion: "Address",
			iban: "IBAN account number",
			seguridad_social: "Social security number",
			pais_nacionalidad: "Country of nationality",
			pais_segunda_nacionalidad: "Second nationality country",
			provincia_nacimiento: "Province of birth",
			lugar_nacimiento: "Place of birth",
			discapacidad: "Disability over 33%",
			deseo_recibir_comunicaciones: "I wish to receive information related to guidance and services regarding  higher education at the UIB",
			nombre: "First name ",
			primer_apellido: "First surname",
			segundo_apellido: "Second surname",
			tipo_identificacion: "Type of identification",
			documento_identidad: "Identification document",
			buscar: "Type to search",
			cp: "Postal Code",
			pais: "Country",
			localidad: "City/Town",
			tipo_via: "Type of street",
			numero: "Number",
			piso: "Floor",
			puerta: "Flat/Apartment/Door",
			notas: "Notes",
			datos_academicos: "Academic information",
			formacion_complementaria: "Additional training",
			anadir_titulacion: "Add new qualification",
			complementaria: "Supplementary",
			centro: "Institution",
			nivel_academico: "Academic level",
			tipo: "Type",
			nota: "Grade",
			rama_ensenanza: "Field of study",
			actual: "Current",
			si: "Yes",
			no: "No",
			titulo: "Degree",
			universidad: "University/Institution",
			calificacion: "Grade",
			calificacion_media: "Average Grade of the degree",
			horas: "Hours",
			ambito: "Area of education",
			selecciona_tipo: "Select a type",
			certificacion: "Certification",
			tienes_cerfificacion: "Do you have Certification?",
			competencias_profesionales: "Professional skills",
			tus_competencias: "Your skills",
			sin_competencias: "No professional skills specified",
			solicitar_sesion: "Need help filling out this section? You can request a free guidance session by clicking this link",
			datos_interes: "Relevant information",
			busqueda_activa_practicas: "Actively seeking internships",
			busqueda_activa_empleo: "Actively seeking employment",
			disponible_extranjero: "Available to work abroad",
			permiso_conducir: "Driver´s license",
			disponible_cambio_residencia: "Willing to relocate",
			coche_propio: "Own vehicle",
			disponible_viajar: "Available to travel",
			discapacidad_certificada: "Certified disability",
			carnet_moto: "Motorcycle license",
			moto_propia: "Own motorcycle",
			disponibilidad_jornadas: "Work schedule availability",
			periodo_preferencia_practicas: "Preferred internship period",
			selecciona: "Select",
			anadir_idioma: "Add language",
			anadir_intereses: "Add interests",
			nuevos_datos_academicos: "New academic information"
		},
		addtitulacion: {
			titulo: "Degrees targeted by the offer",
			seleccione_areas: "Select area(s) to filter degrees",
			borrar_areas: "Clear all areas",
			cualquier_area: "Any area",
			escriba_aqui: "Type here to filter the list of degrees below",
			selecciona_titulacion: "Select the degree(s) targeted by the offer by clicking on them",
			ver_titulaciones: "View undergraduate degrees",
			listadas: "listed",
			listados: "listed",
			cualquier_titulacion: "Any of these undergraduate degrees",
			ver_titulaciones_postgrado: "View postgraduate degrees",
			cualquier_titulacion_postgrado: "Any of these undergraduate degrees",
			ver_titulaciones_propio: "View institutional degrees",
			cualquier_titulacion_propio: "Any of these own degrees",
			lo_sentimos: "Sorry, no degrees matching your search were found",
			listado_titulaciones_seleccionadas: "Selected degrees list",
			eliminar_titulaciones: "Removed all selected degrees"
		},
		candidato: {
			nuevo: "New",
			cambiar_estado: "Change status",
			ver_cv: "View Resume",
			detalles: "Candidate details",
			selecciona_estado: "Select a status",
			seleccione_motivo: "Please select the reason for rejecting the candidate",
			cambio_estado: "Status change",
			descargar_cv: "Download Resume",
			cumplimentar_formulario_incorporacion: "Fill out onboarding form",
			pendiente_form_incorporacion: "Onboarding form pending"
		},
		cambio_practicas: {
			identifica: "Identify the student for whom an extension or change in internship conditions is being requested.",
			alumno: "Student",
			selecciona_oferta: "Select the offer",
			no_practicas: "You don´t have any internship available for change requests.",
			selecciona_alumno: "Select the student",
			detalles: "Modification details",
			tipo_modificacion: "Type of modification",
			selecciona_modificacion: "Select modification type",
			otros_detalles: "Other details",
			adjunto: "Attachment",
			solicitar_cambio: "Request change"
		},
		popup_idioma: {
			titulo: "You are about to change your language preference. Do you want to continue?"
		},
		formulario_incorporacion: {
			formularioYaCumplimentado: "This onboarding form has already been completed and the student has been selected. ",
			encabezado: "Review and complete the onboarding form to verify the internship details, select the student, and formalize the internship.",
			persona_de_contacto: "Contact person",
			contacto_nombre: "First name ",
			contacto_apellidos: "Last name",
			contacto_cargo_departamento: "Position/Department",
			contacto_email: "Email",
			contacto_num_telefono: "Phone number",
			persona_firmante_anexo_convenio: "Annex signatory",
			persona_firmante_convenio_empresa: "Company agreement signatory",
			firmante_nombre: "First name ",
			firmante_apellidos: "Last name",
			firmante_cargo_departamento: "Signatory´s position",
			firmante_email: "Email",
			firmante_telefono: "Phone number",
			datos_alumno: "Student information",
			alumno_dni: "ID number",
			alumno_nombre_apellidos: "Full name",
			alumno_titulacion: "Degree Programme",
			fecha_inicio: "Start date",
			fecha_fin: "End date",
			datos_periodo_practicas: "Internship period information",
			lugar_realizacion_practicas: "Internship Location",
			datos_tutor_empresa: "Company supervisor information",
			tutor_nombre: "First name ",
			tutor_apellidos: "Last name",
			tutor_cargo: "Position in the  Company",
			tutor_email: "Email",
			tutor_dni: "ID number",
			tutor_telefono: "Phone number",
			horario: "Working hours",
			num_horas_dia: "Number of hours per day",
			retribucion_euros_mes: "Gross Monthly Compensation €",
			otras_remuneraciones: "Other Compensations",
			descripcion_actividad: "Detailed description of the student´s tasks (required to assess and approve the internship´s suitability)"
		},
		popup_aceptaSS: {
			info: "Social security information",
			remunerada: "As of January 1, 2024, in accordance with Royal Decree Law 2/2023 (sole article, section 34), in the case of paid training internships, compliance with Social Security obligations will be the responsibility of the entity or organization  funding the training programme, which will be considered the employer for this purpose",
			no_remunerada: "As of January 1, 2024, in accordance with Royal Decree Law 2/2023 (sole article, section 34), in the case of unpaid training internships, Social Security obligations will fall to the company, institution or entity where the internship takes place unless the cooperation agreement or training contract explicity states that the training institution will assume those obligations. If you have any questions or would like to send us a comment, please email us at:careers@cunef.edu",
			entendido: "I have read and understand the Social Security obligations",
			aceptar: "Accept"
		},
		noticia: "New",
		recurso: "Resource",
		novedad: "Update",
		Presencial: "In person",
		Online: "Online",
		Mixta: "Mixed"
	}
}



// WEBPACK FOOTER //
// ./src/translations/index.js